/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Call Sheet API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export type BatchUpdateItemShotDuration = number | null;

export type BatchUpdateItemCustomPropertiesAnyOf = { [key: string]: unknown };

export type BatchUpdateItemCustomProperties = BatchUpdateItemCustomPropertiesAnyOf | null;

export interface BatchUpdateItem {
  id: string;
  shot_duration?: BatchUpdateItemShotDuration;
  custom_properties?: BatchUpdateItemCustomProperties;
}

export interface BodyImportContactsApiContactsImportPost {
  file: Blob;
}

export type BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPostDayId = string | null;

export interface BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost {
  file: Blob;
  title?: string;
  day_id?: BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPostDayId;
}

export interface BodyUploadImageApiShotlistItemsItemIdUploadImagePost {
  file: Blob;
}

export interface BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost {
  file: Blob;
}

export type BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPostCaption = string | null;

export interface BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost {
  file: Blob;
  caption?: BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPostCaption;
}

export interface BroadcastEmail {
  /**
   * @minLength 1
   * @maxLength 200
   */
  subject: string;
  /**
   * @minLength 1
   * @maxLength 10000
   */
  body: string;
}

export interface BroadcastEmailResult {
  sent: number;
  failed: number;
}

export type ClientDescription = string | null;

export interface Client {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: ClientDescription;
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export type ClientCreateDescription = string | null;

export interface ClientCreate {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: ClientCreateDescription;
}

export interface ClientInfo {
  id: string;
  name: string;
}

export type ClientUpdateName = string | null;

export type ClientUpdateDescription = string | null;

export interface ClientUpdate {
  name?: ClientUpdateName;
  description?: ClientUpdateDescription;
}

export interface ComplaintCreate {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  message: string;
}

export type ContactName = string | null;

export type ContactEmail = string | null;

export type ContactCompany = string | null;

export type ContactRole = string | null;

export type ContactCellPhone = string | null;

export type ContactAllergiesDietaryRestrictions = string | null;

export interface Contact {
  name?: ContactName;
  email?: ContactEmail;
  company?: ContactCompany;
  role?: ContactRole;
  cell_phone?: ContactCellPhone;
  allergies_dietary_restrictions?: ContactAllergiesDietaryRestrictions;
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export type ContactCreateName = string | null;

export type ContactCreateEmail = string | null;

export type ContactCreateCompany = string | null;

export type ContactCreateRole = string | null;

export type ContactCreateCellPhone = string | null;

export type ContactCreateAllergiesDietaryRestrictions = string | null;

export interface ContactCreate {
  name?: ContactCreateName;
  email?: ContactCreateEmail;
  company?: ContactCreateCompany;
  role?: ContactCreateRole;
  cell_phone?: ContactCreateCellPhone;
  allergies_dietary_restrictions?: ContactCreateAllergiesDietaryRestrictions;
}

export interface ContactImportResult {
  created: number;
  skipped: number;
  matched_columns: string[];
}

export type ContactUpdateName = string | null;

export type ContactUpdateEmail = string | null;

export type ContactUpdateCompany = string | null;

export type ContactUpdateRole = string | null;

export type ContactUpdateCellPhone = string | null;

export type ContactUpdateAllergiesDietaryRestrictions = string | null;

export interface ContactUpdate {
  name?: ContactUpdateName;
  email?: ContactUpdateEmail;
  company?: ContactUpdateCompany;
  role?: ContactUpdateRole;
  cell_phone?: ContactUpdateCellPhone;
  allergies_dietary_restrictions?: ContactUpdateAllergiesDietaryRestrictions;
}

export interface EmailPasswordRequest {
  /**
   * @minLength 3
   * @maxLength 254
   */
  email: string;
  /**
   * @minLength 8
   * @maxLength 128
   */
  password: string;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export interface ImageResponse {
  url: string;
}

export type InsightsAccountFullName = string | null;

export type InsightsAccountLocation = string | null;

export type InsightsAccountJobTitle = string | null;

export type InsightsAccountPreviousWorkflow = string | null;

export type InsightsAccountShootsPerMonth = string | null;

export type InsightsAccountTypicalSetSize = string | null;

export type InsightsAccountCallSheetHours = string | null;

export interface InsightsAccount {
  id: string;
  email: string;
  full_name?: InsightsAccountFullName;
  location?: InsightsAccountLocation;
  job_title?: InsightsAccountJobTitle;
  previous_workflow?: InsightsAccountPreviousWorkflow;
  shoots_per_month?: InsightsAccountShootsPerMonth;
  typical_set_size?: InsightsAccountTypicalSetSize;
  call_sheet_hours?: InsightsAccountCallSheetHours;
  created_at: string;
  project_count: number;
}

export interface InsightsBucket {
  start: string;
  label: string;
  signups: number;
  viewers: number;
  signed_in_viewers: number;
  guest_viewers: number;
}

export type InsightsComplaintFullName = string | null;

export interface InsightsComplaint {
  id: string;
  email: string;
  full_name?: InsightsComplaintFullName;
  message: string;
  created_at: string;
}

export type InsightsDashboardPeriod = typeof InsightsDashboardPeriod[keyof typeof InsightsDashboardPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsightsDashboardPeriod = {
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
} as const;

export interface InsightsDashboard {
  period: InsightsDashboardPeriod;
  total_users: number;
  total_projects: number;
  signups_in_period: number;
  viewers_in_period: number;
  signed_in_viewers_in_period: number;
  guest_viewers_in_period: number;
  buckets: InsightsBucket[];
  projects: InsightsProject[];
  email_domains: InsightsDomain[];
  accounts: InsightsAccount[];
  complaints: InsightsComplaint[];
}

export interface InsightsDomain {
  domain: string;
  users: number;
}

export interface InsightsProject {
  project_id: string;
  name: string;
  client_name: string;
  viewers: number;
  signed_in_viewers: number;
  guest_viewers: number;
}

export type LunchOrderUserId = string | null;

export type LunchOrderShootMemberId = string | null;

export type LunchOrderGuestName = string | null;

export type LunchOrderDietaryRestrictions = string | null;

export type LunchOrderUserDisplayName = string | null;

export interface LunchOrder {
  id: string;
  shotlist_item_id: string;
  user_id?: LunchOrderUserId;
  shoot_member_id?: LunchOrderShootMemberId;
  guest_name?: LunchOrderGuestName;
  order_text: string;
  dietary_restrictions?: LunchOrderDietaryRestrictions;
  created_at: string;
  updated_at: string;
  user_display_name?: LunchOrderUserDisplayName;
}

export type LunchOrderCreateShootMemberId = string | null;

export type LunchOrderCreateGuestName = string | null;

export type LunchOrderCreateDietaryRestrictions = string | null;

export interface LunchOrderCreate {
  /** @minLength 1 */
  order_text: string;
  shotlist_item_id: string;
  shoot_member_id?: LunchOrderCreateShootMemberId;
  guest_name?: LunchOrderCreateGuestName;
  dietary_restrictions?: LunchOrderCreateDietaryRestrictions;
}

export type LunchOrderUpdateOrderText = string | null;

export type LunchOrderUpdateShootMemberId = string | null;

export type LunchOrderUpdateGuestName = string | null;

export type LunchOrderUpdateDietaryRestrictions = string | null;

export interface LunchOrderUpdate {
  order_text?: LunchOrderUpdateOrderText;
  shoot_member_id?: LunchOrderUpdateShootMemberId;
  guest_name?: LunchOrderUpdateGuestName;
  dietary_restrictions?: LunchOrderUpdateDietaryRestrictions;
}

export interface PaginatedResponseClient {
  items: Client[];
  /** Total number of items */
  total: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  page_size: number;
  /** Total number of pages */
  total_pages: number;
}

export interface PaginatedResponseContact {
  items: Contact[];
  /** Total number of items */
  total: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  page_size: number;
  /** Total number of pages */
  total_pages: number;
}

export interface PaginatedResponseProjectWithClient {
  items: ProjectWithClient[];
  /** Total number of items */
  total: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  page_size: number;
  /** Total number of pages */
  total_pages: number;
}

export type ProjectDescription = string | null;

export type ProjectShootDate = string | null;

export type ProjectCallTime = string | null;

export type ProjectStartTime = string | null;

export type ProjectEndTime = string | null;

export type ProjectLocation = string | null;

export type ProjectHeroImageUrl = string | null;

export type ProjectAuthUserRole = 'owner' | 'public_viewer' | 'collaborator' | null;

export type ProjectPublicShareToken = string | null;

export interface Project {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: ProjectDescription;
  status?: ProjectStatus;
  client_id: string;
  shoot_date?: ProjectShootDate;
  call_time?: ProjectCallTime;
  start_time?: ProjectStartTime;
  end_time?: ProjectEndTime;
  location?: ProjectLocation;
  hero_image_url?: ProjectHeroImageUrl;
  /**
   * @minimum 0
   * @maximum 1
   */
  hero_focus_x?: number;
  /**
   * @minimum 0
   * @maximum 1
   */
  hero_focus_y?: number;
  /**
   * @minimum 1
   * @maximum 3
   */
  hero_scale?: number;
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  authUserRole?: ProjectAuthUserRole;
  public_share_token?: ProjectPublicShareToken;
}

export interface ProjectCollaboratorInvite {
  /**
   * @minLength 3
   * @maxLength 255
   */
  email: string;
}

export type ProjectCollaboratorOutName = string | null;

export type ProjectCollaboratorOutStatus = typeof ProjectCollaboratorOutStatus[keyof typeof ProjectCollaboratorOutStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectCollaboratorOutStatus = {
  pending: 'pending',
  active: 'active',
} as const;

export interface ProjectCollaboratorOut {
  id: string;
  email: string;
  name?: ProjectCollaboratorOutName;
  status: ProjectCollaboratorOutStatus;
}

export type ProjectCreateDescription = string | null;

export type ProjectCreateClientId = string | null;

export type ProjectCreateNewClientName = string | null;

export type ProjectCreateShootDate = string | null;

export type ProjectCreateCallTime = string | null;

export type ProjectCreateStartTime = string | null;

export type ProjectCreateEndTime = string | null;

export type ProjectCreateLocation = string | null;

export interface ProjectCreate {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: ProjectCreateDescription;
  status?: ProjectStatus;
  client_id?: ProjectCreateClientId;
  new_client_name?: ProjectCreateNewClientName;
  shoot_date?: ProjectCreateShootDate;
  call_time?: ProjectCreateCallTime;
  start_time?: ProjectCreateStartTime;
  end_time?: ProjectCreateEndTime;
  location?: ProjectCreateLocation;
}

export type ProjectDayUpdateDescription = string | null;

export type ProjectDayUpdateLocation = string | null;

export type ProjectDayUpdateShootDate = string | null;

export type ProjectDayUpdateCallTime = string | null;

export type ProjectDayUpdateStartTime = string | null;

export type ProjectDayUpdateEndTime = string | null;

export interface ProjectDayUpdate {
  description?: ProjectDayUpdateDescription;
  location?: ProjectDayUpdateLocation;
  shoot_date?: ProjectDayUpdateShootDate;
  call_time?: ProjectDayUpdateCallTime;
  start_time?: ProjectDayUpdateStartTime;
  end_time?: ProjectDayUpdateEndTime;
}

export type ProjectDayWithShotlistDescription = string | null;

export type ProjectDayWithShotlistLocation = string | null;

export type ProjectDayWithShotlistShootDate = string | null;

export type ProjectDayWithShotlistCallTime = string | null;

export type ProjectDayWithShotlistStartTime = string | null;

export type ProjectDayWithShotlistEndTime = string | null;

export interface ProjectDayWithShotlist {
  id: string;
  project_id: string;
  day_number: number;
  description?: ProjectDayWithShotlistDescription;
  location?: ProjectDayWithShotlistLocation;
  shoot_date?: ProjectDayWithShotlistShootDate;
  call_time?: ProjectDayWithShotlistCallTime;
  start_time?: ProjectDayWithShotlistStartTime;
  end_time?: ProjectDayWithShotlistEndTime;
  created_at: string;
  updated_at: string;
  shotlist: ShotlistWithItems;
  shoot_members?: ShootMember[];
  documents?: ProjectDocument[];
}

export type ProjectDocumentUrl = string | null;

export type ProjectDocumentFilePath = string | null;

export type ProjectDocumentFileName = string | null;

export type ProjectDocumentFileType = string | null;

export type ProjectDocumentFileSize = number | null;

export interface ProjectDocument {
  id: string;
  project_id: string;
  day_id: string;
  user_id: string;
  title: string;
  url?: ProjectDocumentUrl;
  file_path?: ProjectDocumentFilePath;
  file_name?: ProjectDocumentFileName;
  file_type?: ProjectDocumentFileType;
  file_size?: ProjectDocumentFileSize;
  order_index: number;
  created_at: string;
  updated_at: string;
}

export type ProjectDocumentCreateUrl = string | null;

export type ProjectDocumentCreateDayId = string | null;

export interface ProjectDocumentCreate {
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  url?: ProjectDocumentCreateUrl;
  day_id?: ProjectDocumentCreateDayId;
}

export type ProjectDocumentUpdateTitle = string | null;

export type ProjectDocumentUpdateUrl = string | null;

export type ProjectDocumentUpdateOrderIndex = number | null;

export interface ProjectDocumentUpdate {
  title?: ProjectDocumentUpdateTitle;
  url?: ProjectDocumentUpdateUrl;
  order_index?: ProjectDocumentUpdateOrderIndex;
}

export interface ProjectPresenceResponse {
  viewers: ProjectViewer[];
}

export interface ProjectShareResponse {
  share_url: string;
}

export type ProjectStatus = typeof ProjectStatus[keyof typeof ProjectStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectStatus = {
  pre_production: 'pre_production',
  production: 'production',
  post_production: 'post_production',
  completed: 'completed',
} as const;

export type ProjectUpdateName = string | null;

export type ProjectUpdateDescription = string | null;

export type ProjectUpdateStatus = ProjectStatus | null;

export type ProjectUpdateShootDate = string | null;

export type ProjectUpdateCallTime = string | null;

export type ProjectUpdateStartTime = string | null;

export type ProjectUpdateEndTime = string | null;

export type ProjectUpdateLocation = string | null;

export type ProjectUpdateHeroFocusX = number | null;

export type ProjectUpdateHeroFocusY = number | null;

export type ProjectUpdateHeroScale = number | null;

export interface ProjectUpdate {
  name?: ProjectUpdateName;
  description?: ProjectUpdateDescription;
  status?: ProjectUpdateStatus;
  shoot_date?: ProjectUpdateShootDate;
  call_time?: ProjectUpdateCallTime;
  start_time?: ProjectUpdateStartTime;
  end_time?: ProjectUpdateEndTime;
  location?: ProjectUpdateLocation;
  hero_focus_x?: ProjectUpdateHeroFocusX;
  hero_focus_y?: ProjectUpdateHeroFocusY;
  hero_scale?: ProjectUpdateHeroScale;
}

export type ProjectViewerEmail = string | null;

export interface ProjectViewer {
  id: string;
  name: string;
  email?: ProjectViewerEmail;
}

export type ProjectWithClientDescription = string | null;

export type ProjectWithClientShootDate = string | null;

export type ProjectWithClientCallTime = string | null;

export type ProjectWithClientStartTime = string | null;

export type ProjectWithClientEndTime = string | null;

export type ProjectWithClientLocation = string | null;

export type ProjectWithClientHeroImageUrl = string | null;

export type ProjectWithClientAuthUserRole = 'owner' | 'public_viewer' | 'collaborator' | null;

export type ProjectWithClientPublicShareToken = string | null;

export interface ProjectWithClient {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: ProjectWithClientDescription;
  status?: ProjectStatus;
  client_id: string;
  shoot_date?: ProjectWithClientShootDate;
  call_time?: ProjectWithClientCallTime;
  start_time?: ProjectWithClientStartTime;
  end_time?: ProjectWithClientEndTime;
  location?: ProjectWithClientLocation;
  hero_image_url?: ProjectWithClientHeroImageUrl;
  /**
   * @minimum 0
   * @maximum 1
   */
  hero_focus_x?: number;
  /**
   * @minimum 0
   * @maximum 1
   */
  hero_focus_y?: number;
  /**
   * @minimum 1
   * @maximum 3
   */
  hero_scale?: number;
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  authUserRole?: ProjectWithClientAuthUserRole;
  public_share_token?: ProjectWithClientPublicShareToken;
  client: ClientInfo;
}

export type ProjectWithFullDataDescription = string | null;

export type ProjectWithFullDataShootDate = string | null;

export type ProjectWithFullDataCallTime = string | null;

export type ProjectWithFullDataStartTime = string | null;

export type ProjectWithFullDataEndTime = string | null;

export type ProjectWithFullDataLocation = string | null;

export type ProjectWithFullDataHeroImageUrl = string | null;

export type ProjectWithFullDataAuthUserRole = 'owner' | 'public_viewer' | 'collaborator' | null;

export type ProjectWithFullDataPublicShareToken = string | null;

export interface ProjectWithFullData {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: ProjectWithFullDataDescription;
  status?: ProjectStatus;
  client_id: string;
  shoot_date?: ProjectWithFullDataShootDate;
  call_time?: ProjectWithFullDataCallTime;
  start_time?: ProjectWithFullDataStartTime;
  end_time?: ProjectWithFullDataEndTime;
  location?: ProjectWithFullDataLocation;
  hero_image_url?: ProjectWithFullDataHeroImageUrl;
  /**
   * @minimum 0
   * @maximum 1
   */
  hero_focus_x?: number;
  /**
   * @minimum 0
   * @maximum 1
   */
  hero_focus_y?: number;
  /**
   * @minimum 1
   * @maximum 3
   */
  hero_scale?: number;
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  authUserRole?: ProjectWithFullDataAuthUserRole;
  public_share_token?: ProjectWithFullDataPublicShareToken;
  shotlist: ShotlistWithItems;
  days?: ProjectDayWithShotlist[];
  shoot_members?: ShootMember[];
  documents?: ProjectDocument[];
  storyboards?: Storyboard[];
  collaborators?: ProjectCollaboratorOut[];
  client: ClientInfo;
}

export type PublicPresenceHeartbeatName = string | null;

export type PublicPresenceHeartbeatShootMemberId = string | null;

export interface PublicPresenceHeartbeat {
  /**
   * @minLength 1
   * @maxLength 80
   */
  viewer_id: string;
  name?: PublicPresenceHeartbeatName;
  shoot_member_id?: PublicPresenceHeartbeatShootMemberId;
}

export interface ReorderRequest {
  item_ids: string[];
}

export type ShootMemberContactId = string | null;

export type ShootMemberClientId = string | null;

export type ShootMemberCallTime = string | null;

export type ShootMemberRole = string | null;

export type ShootMemberName = string | null;

export type ShootMemberEmail = string | null;

export type ShootMemberCellPhone = string | null;

export type ShootMemberAllergiesDietaryRestrictions = string | null;

export type ShootMemberContact = Contact | null;

export type ShootMemberClient = Client | null;

export interface ShootMember {
  contact_id?: ShootMemberContactId;
  /** @pattern ^(crew|client)$ */
  type: string;
  client_id?: ShootMemberClientId;
  call_time?: ShootMemberCallTime;
  role?: ShootMemberRole;
  name?: ShootMemberName;
  email?: ShootMemberEmail;
  cell_phone?: ShootMemberCellPhone;
  allergies_dietary_restrictions?: ShootMemberAllergiesDietaryRestrictions;
  id: string;
  user_id: string;
  project_id: string;
  day_id: string;
  created_at: string;
  updated_at: string;
  contact?: ShootMemberContact;
  client?: ShootMemberClient;
}

export type ShootMemberCreateDayId = string | null;

export interface ShootMemberCreate {
  /** @pattern ^(crew|client)$ */
  type: string;
  day_id?: ShootMemberCreateDayId;
}

export type ShootMemberUpdateContactId = string | null;

export type ShootMemberUpdateCallTime = string | null;

export type ShootMemberUpdateRole = string | null;

export type ShootMemberUpdateName = string | null;

export type ShootMemberUpdateEmail = string | null;

export type ShootMemberUpdateCellPhone = string | null;

export type ShootMemberUpdateAllergiesDietaryRestrictions = string | null;

export interface ShootMemberUpdate {
  contact_id?: ShootMemberUpdateContactId;
  call_time?: ShootMemberUpdateCallTime;
  role?: ShootMemberUpdateRole;
  name?: ShootMemberUpdateName;
  email?: ShootMemberUpdateEmail;
  cell_phone?: ShootMemberUpdateCellPhone;
  allergies_dietary_restrictions?: ShootMemberUpdateAllergiesDietaryRestrictions;
}

export type ShotlistCallTime = string | null;

export type ShotlistWrapTime = string | null;

export interface Shotlist {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  call_time?: ShotlistCallTime;
  wrap_time?: ShotlistWrapTime;
  id: string;
  project_id: string;
  created_at: string;
  updated_at: string;
}

export type ShotlistCreateCallTime = string | null;

export type ShotlistCreateWrapTime = string | null;

export interface ShotlistCreate {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  call_time?: ShotlistCreateCallTime;
  wrap_time?: ShotlistCreateWrapTime;
}

export type ShotlistItemShotType = string | null;

export type ShotlistItemShotDescription = string | null;

export type ShotlistItemStartTime = string | null;

export type ShotlistItemShotReferenceImages = string[] | null;

export type ShotlistItemCameraAngle = string | null;

export type ShotlistItemAspectRatio = string | null;

export type ShotlistItemFps = number | null;

export type ShotlistItemCustomPropertiesAnyOf = { [key: string]: unknown };

export type ShotlistItemCustomProperties = ShotlistItemCustomPropertiesAnyOf | null;

export type ShotlistItemColorIndex = number | null;

export type ShotlistItemLunchOrders = LunchOrder[] | null;

export interface ShotlistItem {
  /**
   * @minLength 1
   * @maxLength 100
   */
  shot_name: string;
  shot_type?: ShotlistItemShotType;
  shot_description?: ShotlistItemShotDescription;
  /**
   * @minimum 1
   * @maximum 1440
   */
  shot_duration: number;
  start_time?: ShotlistItemStartTime;
  shot_reference_images?: ShotlistItemShotReferenceImages;
  /** @minimum 0 */
  order_index: number;
  camera_angle?: ShotlistItemCameraAngle;
  aspect_ratio?: ShotlistItemAspectRatio;
  fps?: ShotlistItemFps;
  custom_properties?: ShotlistItemCustomProperties;
  is_completed?: boolean;
  duration_locked?: boolean;
  is_parallel?: boolean;
  color_index?: ShotlistItemColorIndex;
  id: string;
  shotlist_id: string;
  created_at: string;
  updated_at: string;
  lunch_orders?: ShotlistItemLunchOrders;
}

export type ShotlistItemBatchUpdateIsCompleted = boolean | null;

export type ShotlistItemBatchUpdateDurationLocked = boolean | null;

export type ShotlistItemBatchUpdateIsParallel = boolean | null;

export type ShotlistItemBatchUpdateStartTime = string | null;

export interface ShotlistItemBatchUpdate {
  items: BatchUpdateItem[];
  is_completed?: ShotlistItemBatchUpdateIsCompleted;
  duration_locked?: ShotlistItemBatchUpdateDurationLocked;
  is_parallel?: ShotlistItemBatchUpdateIsParallel;
  start_time?: ShotlistItemBatchUpdateStartTime;
}

export type ShotlistItemCreateShotType = string | null;

export type ShotlistItemCreateShotDescription = string | null;

export type ShotlistItemCreateShotDuration = number | null;

export type ShotlistItemCreateStartTime = string | null;

export type ShotlistItemCreateCameraAngle = string | null;

export type ShotlistItemCreateAspectRatio = string | null;

export type ShotlistItemCreateFps = number | null;

export type ShotlistItemCreateCustomPropertiesAnyOf = { [key: string]: unknown };

export type ShotlistItemCreateCustomProperties = ShotlistItemCreateCustomPropertiesAnyOf | null;

export type ShotlistItemCreateIsCompleted = boolean | null;

export type ShotlistItemCreateDurationLocked = boolean | null;

export type ShotlistItemCreateIsParallel = boolean | null;

export type ShotlistItemCreateColorIndex = number | null;

export interface ShotlistItemCreate {
  /**
   * @minLength 1
   * @maxLength 100
   */
  shot_name: string;
  shot_type?: ShotlistItemCreateShotType;
  shot_description?: ShotlistItemCreateShotDescription;
  shot_duration?: ShotlistItemCreateShotDuration;
  start_time?: ShotlistItemCreateStartTime;
  camera_angle?: ShotlistItemCreateCameraAngle;
  aspect_ratio?: ShotlistItemCreateAspectRatio;
  fps?: ShotlistItemCreateFps;
  custom_properties?: ShotlistItemCreateCustomProperties;
  is_completed?: ShotlistItemCreateIsCompleted;
  duration_locked?: ShotlistItemCreateDurationLocked;
  is_parallel?: ShotlistItemCreateIsParallel;
  color_index?: ShotlistItemCreateColorIndex;
}

export type ShotlistItemUpdateShotName = string | null;

export type ShotlistItemUpdateShotType = string | null;

export type ShotlistItemUpdateShotDescription = string | null;

export type ShotlistItemUpdateShotDuration = number | null;

export type ShotlistItemUpdateStartTime = string | null;

export type ShotlistItemUpdateShotReferenceImages = string[] | null;

export type ShotlistItemUpdateOrderIndex = number | null;

export type ShotlistItemUpdateCameraAngle = string | null;

export type ShotlistItemUpdateAspectRatio = string | null;

export type ShotlistItemUpdateFps = number | null;

export type ShotlistItemUpdateCustomPropertiesAnyOf = { [key: string]: unknown };

export type ShotlistItemUpdateCustomProperties = ShotlistItemUpdateCustomPropertiesAnyOf | null;

export type ShotlistItemUpdateIsCompleted = boolean | null;

export type ShotlistItemUpdateDurationLocked = boolean | null;

export type ShotlistItemUpdateIsParallel = boolean | null;

export type ShotlistItemUpdateColorIndex = number | null;

export interface ShotlistItemUpdate {
  shot_name?: ShotlistItemUpdateShotName;
  shot_type?: ShotlistItemUpdateShotType;
  shot_description?: ShotlistItemUpdateShotDescription;
  shot_duration?: ShotlistItemUpdateShotDuration;
  start_time?: ShotlistItemUpdateStartTime;
  shot_reference_images?: ShotlistItemUpdateShotReferenceImages;
  order_index?: ShotlistItemUpdateOrderIndex;
  camera_angle?: ShotlistItemUpdateCameraAngle;
  aspect_ratio?: ShotlistItemUpdateAspectRatio;
  fps?: ShotlistItemUpdateFps;
  custom_properties?: ShotlistItemUpdateCustomProperties;
  is_completed?: ShotlistItemUpdateIsCompleted;
  duration_locked?: ShotlistItemUpdateDurationLocked;
  is_parallel?: ShotlistItemUpdateIsParallel;
  color_index?: ShotlistItemUpdateColorIndex;
}

export type ShotlistUpdateName = string | null;

export type ShotlistUpdateCallTime = string | null;

export type ShotlistUpdateWrapTime = string | null;

export interface ShotlistUpdate {
  name?: ShotlistUpdateName;
  call_time?: ShotlistUpdateCallTime;
  wrap_time?: ShotlistUpdateWrapTime;
}

export type ShotlistWithItemsCallTime = string | null;

export type ShotlistWithItemsWrapTime = string | null;

export interface ShotlistWithItems {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  call_time?: ShotlistWithItemsCallTime;
  wrap_time?: ShotlistWithItemsWrapTime;
  id: string;
  project_id: string;
  created_at: string;
  updated_at: string;
  items?: ShotlistItem[];
}

export type SignupResearchRequestShootsPerMonth = typeof SignupResearchRequestShootsPerMonth[keyof typeof SignupResearchRequestShootsPerMonth];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupResearchRequestShootsPerMonth = {
  '1-2': '1-2',
  '2-3': '2-3',
  '4-5': '4-5',
  '5+': '5+',
} as const;

export type SignupResearchRequestTypicalSetSize = typeof SignupResearchRequestTypicalSetSize[keyof typeof SignupResearchRequestTypicalSetSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupResearchRequestTypicalSetSize = {
  '1-10': '1-10',
  '10-20': '10-20',
  '20-30': '20-30',
  '30-40': '30-40',
  '40+': '40+',
} as const;

export type SignupResearchRequestCallSheetHours = typeof SignupResearchRequestCallSheetHours[keyof typeof SignupResearchRequestCallSheetHours];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupResearchRequestCallSheetHours = {
  '1_hour': '1 hour',
  '2_hours': '2 hours',
  '3_hours': '3 hours',
  '4+_hours': '4+ hours',
} as const;

export interface SignupResearchRequest {
  /**
   * @minLength 1
   * @maxLength 120
   */
  full_name: string;
  /**
   * @minLength 1
   * @maxLength 120
   */
  location: string;
  /**
   * @minLength 1
   * @maxLength 80
   */
  job_title: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  previous_workflow: string;
  shoots_per_month: SignupResearchRequestShootsPerMonth;
  typical_set_size: SignupResearchRequestTypicalSetSize;
  call_sheet_hours: SignupResearchRequestCallSheetHours;
}

export interface Storyboard {
  id: string;
  project_id: string;
  name: string;
  order_index: number;
  frames?: StoryboardFrame[];
  created_at: string;
  updated_at: string;
}

export interface StoryboardCreate {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export type StoryboardFrameUrl = string | null;

export type StoryboardFrameCaption = string | null;

export type StoryboardFrameShotlistItemId = string | null;

export interface StoryboardFrame {
  id: string;
  project_id: string;
  storyboard_id: string;
  user_id: string;
  url?: StoryboardFrameUrl;
  caption?: StoryboardFrameCaption;
  order_index: number;
  shotlist_item_id?: StoryboardFrameShotlistItemId;
  created_at: string;
  updated_at: string;
}

export type StoryboardFrameAssignFrameId = string | null;

/**
 * Assign (or clear) the storyboard frame linked to a shot.
 */
export interface StoryboardFrameAssign {
  frame_id?: StoryboardFrameAssignFrameId;
}

export interface StoryboardFrameReorder {
  frame_ids: string[];
}

export type StoryboardFrameUpdateCaption = string | null;

export type StoryboardFrameUpdateOrderIndex = number | null;

export interface StoryboardFrameUpdate {
  caption?: StoryboardFrameUpdateCaption;
  order_index?: StoryboardFrameUpdateOrderIndex;
}

export type StoryboardUpdateName = string | null;

export type StoryboardUpdateOrderIndex = number | null;

export interface StoryboardUpdate {
  name?: StoryboardUpdateName;
  order_index?: StoryboardUpdateOrderIndex;
}

export type UserFullName = string | null;

export interface User {
  id: string;
  email: string;
  full_name?: UserFullName;
  research_completed: boolean;
}

export type ValidationErrorLocItem = string | number;

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
}

export type LoginGoogleApiAuthLoginGoogleGetParams = {
login_hint?: string | null;
};

export type UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutParams = {
shoot_member_id?: string | null;
guest_name?: string | null;
};

export type DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteParams = {
shoot_member_id?: string | null;
guest_name?: string | null;
};

export type ReadInsightsApiInsightsGetParams = {
period?: ReadInsightsApiInsightsGetPeriod;
};

export type ReadInsightsApiInsightsGetPeriod = typeof ReadInsightsApiInsightsGetPeriod[keyof typeof ReadInsightsApiInsightsGetPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReadInsightsApiInsightsGetPeriod = {
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
} as const;

export type ReadClientsApiClientsGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
page_size?: number;
search?: string | null;
sort_by?: string | null;
sort_order?: string | null;
};

export type ReadProjectsApiProjectsGetParams = {
client_id?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
page_size?: number;
search?: string | null;
sort_by?: string | null;
sort_order?: string | null;
};

export type ReadContactsApiContactsGetParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
page_size?: number;
search?: string | null;
sort_by?: string | null;
sort_order?: string | null;
};

/**
 * Health check endpoint for monitoring and deployment systems
 * @summary Health Check
 */
export const healthCheckApiV1HealthGet = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.get(
      `/api/v1/health`,options
    );
  }




export const getHealthCheckApiV1HealthGetQueryKey = () => {
    return [
    `/api/v1/health`
    ] as const;
    }

    
export const getHealthCheckApiV1HealthGetQueryOptions = <TData = Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckApiV1HealthGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>> = ({ signal }) => healthCheckApiV1HealthGet({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthCheckApiV1HealthGetQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>>
export type HealthCheckApiV1HealthGetQueryError = AxiosError<unknown>


export function useHealthCheckApiV1HealthGet<TData = Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheckApiV1HealthGet<TData = Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheckApiV1HealthGet<TData = Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health Check
 */

export function useHealthCheckApiV1HealthGet<TData = Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheckApiV1HealthGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthCheckApiV1HealthGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Start Google sign-in. An optional email prefills the Google account picker.
 * @summary Login Google
 */
export const loginGoogleApiAuthLoginGoogleGet = (
    params?: LoginGoogleApiAuthLoginGoogleGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.get(
      `/api/auth/login/google`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getLoginGoogleApiAuthLoginGoogleGetQueryKey = (params?: LoginGoogleApiAuthLoginGoogleGetParams,) => {
    return [
    `/api/auth/login/google`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getLoginGoogleApiAuthLoginGoogleGetQueryOptions = <TData = Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError = AxiosError<HTTPValidationError>>(params?: LoginGoogleApiAuthLoginGoogleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginGoogleApiAuthLoginGoogleGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>> = ({ signal }) => loginGoogleApiAuthLoginGoogleGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginGoogleApiAuthLoginGoogleGetQueryResult = NonNullable<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>>
export type LoginGoogleApiAuthLoginGoogleGetQueryError = AxiosError<HTTPValidationError>


export function useLoginGoogleApiAuthLoginGoogleGet<TData = Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError = AxiosError<HTTPValidationError>>(
 params: undefined |  LoginGoogleApiAuthLoginGoogleGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>,
          TError,
          Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginGoogleApiAuthLoginGoogleGet<TData = Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: LoginGoogleApiAuthLoginGoogleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>,
          TError,
          Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginGoogleApiAuthLoginGoogleGet<TData = Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: LoginGoogleApiAuthLoginGoogleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Login Google
 */

export function useLoginGoogleApiAuthLoginGoogleGet<TData = Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: LoginGoogleApiAuthLoginGoogleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginGoogleApiAuthLoginGoogleGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginGoogleApiAuthLoginGoogleGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Auth Google Callback
 */
export const authGoogleCallbackApiAuthGoogleCallbackGet = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.get(
      `/api/auth/google/callback`,options
    );
  }




export const getAuthGoogleCallbackApiAuthGoogleCallbackGetQueryKey = () => {
    return [
    `/api/auth/google/callback`
    ] as const;
    }

    
export const getAuthGoogleCallbackApiAuthGoogleCallbackGetQueryOptions = <TData = Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthGoogleCallbackApiAuthGoogleCallbackGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>> = ({ signal }) => authGoogleCallbackApiAuthGoogleCallbackGet({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthGoogleCallbackApiAuthGoogleCallbackGetQueryResult = NonNullable<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>>
export type AuthGoogleCallbackApiAuthGoogleCallbackGetQueryError = AxiosError<unknown>


export function useAuthGoogleCallbackApiAuthGoogleCallbackGet<TData = Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGoogleCallbackApiAuthGoogleCallbackGet<TData = Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGoogleCallbackApiAuthGoogleCallbackGet<TData = Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Auth Google Callback
 */

export function useAuthGoogleCallbackApiAuthGoogleCallbackGet<TData = Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGoogleCallbackApiAuthGoogleCallbackGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthGoogleCallbackApiAuthGoogleCallbackGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a password account, or sign in when one already exists.
 * @summary Login With Email
 */
export const loginWithEmailApiAuthEmailPost = (
    emailPasswordRequest: EmailPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    
    return axios.default.post(
      `/api/auth/email`,
      emailPasswordRequest,options
    );
  }



export const getLoginWithEmailApiAuthEmailPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithEmailApiAuthEmailPost>>, TError,{data: EmailPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof loginWithEmailApiAuthEmailPost>>, TError,{data: EmailPasswordRequest}, TContext> => {

const mutationKey = ['loginWithEmailApiAuthEmailPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginWithEmailApiAuthEmailPost>>, {data: EmailPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  loginWithEmailApiAuthEmailPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginWithEmailApiAuthEmailPostMutationResult = NonNullable<Awaited<ReturnType<typeof loginWithEmailApiAuthEmailPost>>>
    export type LoginWithEmailApiAuthEmailPostMutationBody = EmailPasswordRequest
    export type LoginWithEmailApiAuthEmailPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Login With Email
 */
export const useLoginWithEmailApiAuthEmailPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithEmailApiAuthEmailPost>>, TError,{data: EmailPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginWithEmailApiAuthEmailPost>>,
        TError,
        {data: EmailPasswordRequest},
        TContext
      > => {

      const mutationOptions = getLoginWithEmailApiAuthEmailPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Logout
 */
export const logoutApiAuthLogoutPost = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.post(
      `/api/auth/logout`,undefined,options
    );
  }



export const getLogoutApiAuthLogoutPostMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, TError,void, TContext> => {

const mutationKey = ['logoutApiAuthLogoutPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, void> = () => {
          

          return  logoutApiAuthLogoutPost(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutApiAuthLogoutPostMutationResult = NonNullable<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>>
    
    export type LogoutApiAuthLogoutPostMutationError = AxiosError<unknown>

    /**
 * @summary Logout
 */
export const useLogoutApiAuthLogoutPost = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutApiAuthLogoutPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get Current User
 */
export const getCurrentUserApiAuthMeGet = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    
    return axios.default.get(
      `/api/auth/me`,options
    );
  }




export const getGetCurrentUserApiAuthMeGetQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }

    
export const getGetCurrentUserApiAuthMeGetQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserApiAuthMeGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>> = ({ signal }) => getCurrentUserApiAuthMeGet({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserApiAuthMeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>>
export type GetCurrentUserApiAuthMeGetQueryError = AxiosError<unknown>


export function useGetCurrentUserApiAuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserApiAuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserApiAuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Current User
 */

export function useGetCurrentUserApiAuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiAuthMeGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserApiAuthMeGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Save the short research form required for new accounts.
 * @summary Submit Signup Research
 */
export const submitSignupResearchApiAuthResearchPost = (
    signupResearchRequest: SignupResearchRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    
    return axios.default.post(
      `/api/auth/research`,
      signupResearchRequest,options
    );
  }



export const getSubmitSignupResearchApiAuthResearchPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSignupResearchApiAuthResearchPost>>, TError,{data: SignupResearchRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof submitSignupResearchApiAuthResearchPost>>, TError,{data: SignupResearchRequest}, TContext> => {

const mutationKey = ['submitSignupResearchApiAuthResearchPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitSignupResearchApiAuthResearchPost>>, {data: SignupResearchRequest}> = (props) => {
          const {data} = props ?? {};

          return  submitSignupResearchApiAuthResearchPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitSignupResearchApiAuthResearchPostMutationResult = NonNullable<Awaited<ReturnType<typeof submitSignupResearchApiAuthResearchPost>>>
    export type SubmitSignupResearchApiAuthResearchPostMutationBody = SignupResearchRequest
    export type SubmitSignupResearchApiAuthResearchPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Submit Signup Research
 */
export const useSubmitSignupResearchApiAuthResearchPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSignupResearchApiAuthResearchPost>>, TError,{data: SignupResearchRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitSignupResearchApiAuthResearchPost>>,
        TError,
        {data: SignupResearchRequest},
        TContext
      > => {

      const mutationOptions = getSubmitSignupResearchApiAuthResearchPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Public endpoint to view a project via share token. No authentication required.
 * @summary Read Public Project
 */
export const readPublicProjectApiPublicProjectsShareTokenGet = (
    shareToken: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectWithFullData>> => {
    
    
    return axios.default.get(
      `/api/public/projects/${shareToken}`,options
    );
  }




export const getReadPublicProjectApiPublicProjectsShareTokenGetQueryKey = (shareToken?: string,) => {
    return [
    `/api/public/projects/${shareToken}`
    ] as const;
    }

    
export const getReadPublicProjectApiPublicProjectsShareTokenGetQueryOptions = <TData = Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError = AxiosError<HTTPValidationError>>(shareToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadPublicProjectApiPublicProjectsShareTokenGetQueryKey(shareToken);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>> = ({ signal }) => readPublicProjectApiPublicProjectsShareTokenGet(shareToken, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(shareToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadPublicProjectApiPublicProjectsShareTokenGetQueryResult = NonNullable<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>>
export type ReadPublicProjectApiPublicProjectsShareTokenGetQueryError = AxiosError<HTTPValidationError>


export function useReadPublicProjectApiPublicProjectsShareTokenGet<TData = Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError = AxiosError<HTTPValidationError>>(
 shareToken: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>,
          TError,
          Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadPublicProjectApiPublicProjectsShareTokenGet<TData = Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError = AxiosError<HTTPValidationError>>(
 shareToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>,
          TError,
          Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadPublicProjectApiPublicProjectsShareTokenGet<TData = Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError = AxiosError<HTTPValidationError>>(
 shareToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Public Project
 */

export function useReadPublicProjectApiPublicProjectsShareTokenGet<TData = Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError = AxiosError<HTTPValidationError>>(
 shareToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readPublicProjectApiPublicProjectsShareTokenGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadPublicProjectApiPublicProjectsShareTokenGetQueryOptions(shareToken,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Record a public viewer on a shared project and return active viewers.
 * @summary Heartbeat Public Presence
 */
export const heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost = (
    shareToken: string,
    publicPresenceHeartbeat: PublicPresenceHeartbeat, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectPresenceResponse>> => {
    
    
    return axios.default.post(
      `/api/public/projects/${shareToken}/presence`,
      publicPresenceHeartbeat,options
    );
  }



export const getHeartbeatPublicPresenceApiPublicProjectsShareTokenPresencePostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost>>, TError,{shareToken: string;data: PublicPresenceHeartbeat}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost>>, TError,{shareToken: string;data: PublicPresenceHeartbeat}, TContext> => {

const mutationKey = ['heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost>>, {shareToken: string;data: PublicPresenceHeartbeat}> = (props) => {
          const {shareToken,data} = props ?? {};

          return  heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost(shareToken,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HeartbeatPublicPresenceApiPublicProjectsShareTokenPresencePostMutationResult = NonNullable<Awaited<ReturnType<typeof heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost>>>
    export type HeartbeatPublicPresenceApiPublicProjectsShareTokenPresencePostMutationBody = PublicPresenceHeartbeat
    export type HeartbeatPublicPresenceApiPublicProjectsShareTokenPresencePostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Heartbeat Public Presence
 */
export const useHeartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost>>, TError,{shareToken: string;data: PublicPresenceHeartbeat}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof heartbeatPublicPresenceApiPublicProjectsShareTokenPresencePost>>,
        TError,
        {shareToken: string;data: PublicPresenceHeartbeat},
        TContext
      > => {

      const mutationOptions = getHeartbeatPublicPresenceApiPublicProjectsShareTokenPresencePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a lunch order for a public user (via share token).
 * @summary Create Public Lunch Order
 */
export const createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost = (
    shareToken: string,
    lunchOrderCreate: LunchOrderCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LunchOrder>> => {
    
    
    return axios.default.post(
      `/api/public/projects/${shareToken}/lunch-orders`,
      lunchOrderCreate,options
    );
  }



export const getCreatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost>>, TError,{shareToken: string;data: LunchOrderCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost>>, TError,{shareToken: string;data: LunchOrderCreate}, TContext> => {

const mutationKey = ['createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost>>, {shareToken: string;data: LunchOrderCreate}> = (props) => {
          const {shareToken,data} = props ?? {};

          return  createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost(shareToken,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost>>>
    export type CreatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPostMutationBody = LunchOrderCreate
    export type CreatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Public Lunch Order
 */
export const useCreatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost>>, TError,{shareToken: string;data: LunchOrderCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPost>>,
        TError,
        {shareToken: string;data: LunchOrderCreate},
        TContext
      > => {

      const mutationOptions = getCreatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a lunch order for a public user (verified by share_token and shoot_member_id or guest_name).
 * @summary Update Public Lunch Order
 */
export const updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut = (
    shareToken: string,
    orderId: string,
    lunchOrderUpdate: LunchOrderUpdate,
    params?: UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LunchOrder>> => {
    
    
    return axios.default.put(
      `/api/public/projects/${shareToken}/lunch-orders/${orderId}`,
      lunchOrderUpdate,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getUpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut>>, TError,{shareToken: string;orderId: string;data: LunchOrderUpdate;params?: UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut>>, TError,{shareToken: string;orderId: string;data: LunchOrderUpdate;params?: UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutParams}, TContext> => {

const mutationKey = ['updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut>>, {shareToken: string;orderId: string;data: LunchOrderUpdate;params?: UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutParams}> = (props) => {
          const {shareToken,orderId,data,params} = props ?? {};

          return  updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut(shareToken,orderId,data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut>>>
    export type UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutMutationBody = LunchOrderUpdate
    export type UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Public Lunch Order
 */
export const useUpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut>>, TError,{shareToken: string;orderId: string;data: LunchOrderUpdate;params?: UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPut>>,
        TError,
        {shareToken: string;orderId: string;data: LunchOrderUpdate;params?: UpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutParams},
        TContext
      > => {

      const mutationOptions = getUpdatePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a lunch order for a public user (verified by share_token and shoot_member_id or guest_name).
 * @summary Delete Public Lunch Order
 */
export const deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete = (
    shareToken: string,
    orderId: string,
    params?: DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/public/projects/${shareToken}/lunch-orders/${orderId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete>>, TError,{shareToken: string;orderId: string;params?: DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete>>, TError,{shareToken: string;orderId: string;params?: DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteParams}, TContext> => {

const mutationKey = ['deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete>>, {shareToken: string;orderId: string;params?: DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteParams}> = (props) => {
          const {shareToken,orderId,params} = props ?? {};

          return  deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete(shareToken,orderId,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete>>>
    
    export type DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Public Lunch Order
 */
export const useDeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete>>, TError,{shareToken: string;orderId: string;params?: DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDelete>>,
        TError,
        {shareToken: string;orderId: string;params?: DeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeletePublicLunchOrderApiPublicProjectsShareTokenLunchOrdersOrderIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Signup, project-view, account, and complaint totals for the master page.
 * @summary Read Insights
 */
export const readInsightsApiInsightsGet = (
    params?: ReadInsightsApiInsightsGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InsightsDashboard>> => {
    
    
    return axios.default.get(
      `/api/insights`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getReadInsightsApiInsightsGetQueryKey = (params?: ReadInsightsApiInsightsGetParams,) => {
    return [
    `/api/insights`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReadInsightsApiInsightsGetQueryOptions = <TData = Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError = AxiosError<HTTPValidationError>>(params?: ReadInsightsApiInsightsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadInsightsApiInsightsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>> = ({ signal }) => readInsightsApiInsightsGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadInsightsApiInsightsGetQueryResult = NonNullable<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>>
export type ReadInsightsApiInsightsGetQueryError = AxiosError<HTTPValidationError>


export function useReadInsightsApiInsightsGet<TData = Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError = AxiosError<HTTPValidationError>>(
 params: undefined |  ReadInsightsApiInsightsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readInsightsApiInsightsGet>>,
          TError,
          Awaited<ReturnType<typeof readInsightsApiInsightsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadInsightsApiInsightsGet<TData = Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadInsightsApiInsightsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readInsightsApiInsightsGet>>,
          TError,
          Awaited<ReturnType<typeof readInsightsApiInsightsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadInsightsApiInsightsGet<TData = Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadInsightsApiInsightsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Insights
 */

export function useReadInsightsApiInsightsGet<TData = Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadInsightsApiInsightsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readInsightsApiInsightsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadInsightsApiInsightsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Email every account. Only the master account can send this.
 * @summary Broadcast Email
 */
export const broadcastEmailApiInsightsBroadcastPost = (
    broadcastEmail: BroadcastEmail, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BroadcastEmailResult>> => {
    
    
    return axios.default.post(
      `/api/insights/broadcast`,
      broadcastEmail,options
    );
  }



export const getBroadcastEmailApiInsightsBroadcastPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof broadcastEmailApiInsightsBroadcastPost>>, TError,{data: BroadcastEmail}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof broadcastEmailApiInsightsBroadcastPost>>, TError,{data: BroadcastEmail}, TContext> => {

const mutationKey = ['broadcastEmailApiInsightsBroadcastPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof broadcastEmailApiInsightsBroadcastPost>>, {data: BroadcastEmail}> = (props) => {
          const {data} = props ?? {};

          return  broadcastEmailApiInsightsBroadcastPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BroadcastEmailApiInsightsBroadcastPostMutationResult = NonNullable<Awaited<ReturnType<typeof broadcastEmailApiInsightsBroadcastPost>>>
    export type BroadcastEmailApiInsightsBroadcastPostMutationBody = BroadcastEmail
    export type BroadcastEmailApiInsightsBroadcastPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Broadcast Email
 */
export const useBroadcastEmailApiInsightsBroadcastPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof broadcastEmailApiInsightsBroadcastPost>>, TError,{data: BroadcastEmail}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof broadcastEmailApiInsightsBroadcastPost>>,
        TError,
        {data: BroadcastEmail},
        TContext
      > => {

      const mutationOptions = getBroadcastEmailApiInsightsBroadcastPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Store a problem report from the signed-in account.
 * @summary Create Complaint
 */
export const createComplaintApiComplaintsPost = (
    complaintCreate: ComplaintCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.post(
      `/api/complaints`,
      complaintCreate,options
    );
  }



export const getCreateComplaintApiComplaintsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplaintApiComplaintsPost>>, TError,{data: ComplaintCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createComplaintApiComplaintsPost>>, TError,{data: ComplaintCreate}, TContext> => {

const mutationKey = ['createComplaintApiComplaintsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createComplaintApiComplaintsPost>>, {data: ComplaintCreate}> = (props) => {
          const {data} = props ?? {};

          return  createComplaintApiComplaintsPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateComplaintApiComplaintsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createComplaintApiComplaintsPost>>>
    export type CreateComplaintApiComplaintsPostMutationBody = ComplaintCreate
    export type CreateComplaintApiComplaintsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Complaint
 */
export const useCreateComplaintApiComplaintsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplaintApiComplaintsPost>>, TError,{data: ComplaintCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createComplaintApiComplaintsPost>>,
        TError,
        {data: ComplaintCreate},
        TContext
      > => {

      const mutationOptions = getCreateComplaintApiComplaintsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read Clients
 */
export const readClientsApiClientsGet = (
    params?: ReadClientsApiClientsGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PaginatedResponseClient>> => {
    
    
    return axios.default.get(
      `/api/clients/`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getReadClientsApiClientsGetQueryKey = (params?: ReadClientsApiClientsGetParams,) => {
    return [
    `/api/clients/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReadClientsApiClientsGetQueryOptions = <TData = Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError = AxiosError<HTTPValidationError>>(params?: ReadClientsApiClientsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadClientsApiClientsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readClientsApiClientsGet>>> = ({ signal }) => readClientsApiClientsGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadClientsApiClientsGetQueryResult = NonNullable<Awaited<ReturnType<typeof readClientsApiClientsGet>>>
export type ReadClientsApiClientsGetQueryError = AxiosError<HTTPValidationError>


export function useReadClientsApiClientsGet<TData = Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError = AxiosError<HTTPValidationError>>(
 params: undefined |  ReadClientsApiClientsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readClientsApiClientsGet>>,
          TError,
          Awaited<ReturnType<typeof readClientsApiClientsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadClientsApiClientsGet<TData = Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadClientsApiClientsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readClientsApiClientsGet>>,
          TError,
          Awaited<ReturnType<typeof readClientsApiClientsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadClientsApiClientsGet<TData = Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadClientsApiClientsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Clients
 */

export function useReadClientsApiClientsGet<TData = Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadClientsApiClientsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientsApiClientsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadClientsApiClientsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create Client
 */
export const createClientApiClientsPost = (
    clientCreate: ClientCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Client>> => {
    
    
    return axios.default.post(
      `/api/clients/`,
      clientCreate,options
    );
  }



export const getCreateClientApiClientsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClientApiClientsPost>>, TError,{data: ClientCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createClientApiClientsPost>>, TError,{data: ClientCreate}, TContext> => {

const mutationKey = ['createClientApiClientsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClientApiClientsPost>>, {data: ClientCreate}> = (props) => {
          const {data} = props ?? {};

          return  createClientApiClientsPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateClientApiClientsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createClientApiClientsPost>>>
    export type CreateClientApiClientsPostMutationBody = ClientCreate
    export type CreateClientApiClientsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Client
 */
export const useCreateClientApiClientsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClientApiClientsPost>>, TError,{data: ClientCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createClientApiClientsPost>>,
        TError,
        {data: ClientCreate},
        TContext
      > => {

      const mutationOptions = getCreateClientApiClientsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read Client
 */
export const readClientApiClientsClientIdGet = (
    clientId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Client>> => {
    
    
    return axios.default.get(
      `/api/clients/${clientId}`,options
    );
  }




export const getReadClientApiClientsClientIdGetQueryKey = (clientId?: string,) => {
    return [
    `/api/clients/${clientId}`
    ] as const;
    }

    
export const getReadClientApiClientsClientIdGetQueryOptions = <TData = Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError = AxiosError<HTTPValidationError>>(clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadClientApiClientsClientIdGetQueryKey(clientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>> = ({ signal }) => readClientApiClientsClientIdGet(clientId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadClientApiClientsClientIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>>
export type ReadClientApiClientsClientIdGetQueryError = AxiosError<HTTPValidationError>


export function useReadClientApiClientsClientIdGet<TData = Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError = AxiosError<HTTPValidationError>>(
 clientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>,
          TError,
          Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadClientApiClientsClientIdGet<TData = Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError = AxiosError<HTTPValidationError>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>,
          TError,
          Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadClientApiClientsClientIdGet<TData = Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError = AxiosError<HTTPValidationError>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Client
 */

export function useReadClientApiClientsClientIdGet<TData = Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError = AxiosError<HTTPValidationError>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readClientApiClientsClientIdGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadClientApiClientsClientIdGetQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update Client
 */
export const updateClientApiClientsClientIdPut = (
    clientId: string,
    clientUpdate: ClientUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Client>> => {
    
    
    return axios.default.put(
      `/api/clients/${clientId}`,
      clientUpdate,options
    );
  }



export const getUpdateClientApiClientsClientIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClientApiClientsClientIdPut>>, TError,{clientId: string;data: ClientUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateClientApiClientsClientIdPut>>, TError,{clientId: string;data: ClientUpdate}, TContext> => {

const mutationKey = ['updateClientApiClientsClientIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClientApiClientsClientIdPut>>, {clientId: string;data: ClientUpdate}> = (props) => {
          const {clientId,data} = props ?? {};

          return  updateClientApiClientsClientIdPut(clientId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateClientApiClientsClientIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateClientApiClientsClientIdPut>>>
    export type UpdateClientApiClientsClientIdPutMutationBody = ClientUpdate
    export type UpdateClientApiClientsClientIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Client
 */
export const useUpdateClientApiClientsClientIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClientApiClientsClientIdPut>>, TError,{clientId: string;data: ClientUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateClientApiClientsClientIdPut>>,
        TError,
        {clientId: string;data: ClientUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateClientApiClientsClientIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Client
 */
export const deleteClientApiClientsClientIdDelete = (
    clientId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/clients/${clientId}`,options
    );
  }



export const getDeleteClientApiClientsClientIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClientApiClientsClientIdDelete>>, TError,{clientId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClientApiClientsClientIdDelete>>, TError,{clientId: string}, TContext> => {

const mutationKey = ['deleteClientApiClientsClientIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClientApiClientsClientIdDelete>>, {clientId: string}> = (props) => {
          const {clientId} = props ?? {};

          return  deleteClientApiClientsClientIdDelete(clientId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClientApiClientsClientIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClientApiClientsClientIdDelete>>>
    
    export type DeleteClientApiClientsClientIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Client
 */
export const useDeleteClientApiClientsClientIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClientApiClientsClientIdDelete>>, TError,{clientId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteClientApiClientsClientIdDelete>>,
        TError,
        {clientId: string},
        TContext
      > => {

      const mutationOptions = getDeleteClientApiClientsClientIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read Projects
 */
export const readProjectsApiProjectsGet = (
    params?: ReadProjectsApiProjectsGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PaginatedResponseProjectWithClient>> => {
    
    
    return axios.default.get(
      `/api/projects/`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getReadProjectsApiProjectsGetQueryKey = (params?: ReadProjectsApiProjectsGetParams,) => {
    return [
    `/api/projects/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReadProjectsApiProjectsGetQueryOptions = <TData = Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError = AxiosError<HTTPValidationError>>(params?: ReadProjectsApiProjectsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadProjectsApiProjectsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>> = ({ signal }) => readProjectsApiProjectsGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadProjectsApiProjectsGetQueryResult = NonNullable<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>>
export type ReadProjectsApiProjectsGetQueryError = AxiosError<HTTPValidationError>


export function useReadProjectsApiProjectsGet<TData = Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError = AxiosError<HTTPValidationError>>(
 params: undefined |  ReadProjectsApiProjectsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readProjectsApiProjectsGet>>,
          TError,
          Awaited<ReturnType<typeof readProjectsApiProjectsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadProjectsApiProjectsGet<TData = Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadProjectsApiProjectsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readProjectsApiProjectsGet>>,
          TError,
          Awaited<ReturnType<typeof readProjectsApiProjectsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadProjectsApiProjectsGet<TData = Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadProjectsApiProjectsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Projects
 */

export function useReadProjectsApiProjectsGet<TData = Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadProjectsApiProjectsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectsApiProjectsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadProjectsApiProjectsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create Project
 */
export const createProjectApiProjectsPost = (
    projectCreate: ProjectCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Project>> => {
    
    
    return axios.default.post(
      `/api/projects/`,
      projectCreate,options
    );
  }



export const getCreateProjectApiProjectsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectApiProjectsPost>>, TError,{data: ProjectCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectApiProjectsPost>>, TError,{data: ProjectCreate}, TContext> => {

const mutationKey = ['createProjectApiProjectsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectApiProjectsPost>>, {data: ProjectCreate}> = (props) => {
          const {data} = props ?? {};

          return  createProjectApiProjectsPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectApiProjectsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectApiProjectsPost>>>
    export type CreateProjectApiProjectsPostMutationBody = ProjectCreate
    export type CreateProjectApiProjectsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Project
 */
export const useCreateProjectApiProjectsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectApiProjectsPost>>, TError,{data: ProjectCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectApiProjectsPost>>,
        TError,
        {data: ProjectCreate},
        TContext
      > => {

      const mutationOptions = getCreateProjectApiProjectsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Copy a project, including its crew, so the next shoot can start from it.
 * @summary Duplicate Project
 */
export const duplicateProjectApiProjectsProjectIdDuplicatePost = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Project>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/duplicate`,undefined,options
    );
  }



export const getDuplicateProjectApiProjectsProjectIdDuplicatePostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateProjectApiProjectsProjectIdDuplicatePost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateProjectApiProjectsProjectIdDuplicatePost>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['duplicateProjectApiProjectsProjectIdDuplicatePost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateProjectApiProjectsProjectIdDuplicatePost>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  duplicateProjectApiProjectsProjectIdDuplicatePost(projectId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DuplicateProjectApiProjectsProjectIdDuplicatePostMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateProjectApiProjectsProjectIdDuplicatePost>>>
    
    export type DuplicateProjectApiProjectsProjectIdDuplicatePostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Duplicate Project
 */
export const useDuplicateProjectApiProjectsProjectIdDuplicatePost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateProjectApiProjectsProjectIdDuplicatePost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicateProjectApiProjectsProjectIdDuplicatePost>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getDuplicateProjectApiProjectsProjectIdDuplicatePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Upload a hero / thumbnail image that represents the project.
 * @summary Upload Project Hero Image
 */
export const uploadProjectHeroImageApiProjectsProjectIdHeroImagePost = (
    projectId: string,
    bodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost: BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImageResponse>> => {
    
    const formData = new FormData();
formData.append(`file`, bodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost.file)

    return axios.default.post(
      `/api/projects/${projectId}/hero-image`,
      formData,options
    );
  }



export const getUploadProjectHeroImageApiProjectsProjectIdHeroImagePostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadProjectHeroImageApiProjectsProjectIdHeroImagePost>>, TError,{projectId: string;data: BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadProjectHeroImageApiProjectsProjectIdHeroImagePost>>, TError,{projectId: string;data: BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost}, TContext> => {

const mutationKey = ['uploadProjectHeroImageApiProjectsProjectIdHeroImagePost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadProjectHeroImageApiProjectsProjectIdHeroImagePost>>, {projectId: string;data: BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost}> = (props) => {
          const {projectId,data} = props ?? {};

          return  uploadProjectHeroImageApiProjectsProjectIdHeroImagePost(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadProjectHeroImageApiProjectsProjectIdHeroImagePostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadProjectHeroImageApiProjectsProjectIdHeroImagePost>>>
    export type UploadProjectHeroImageApiProjectsProjectIdHeroImagePostMutationBody = BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost
    export type UploadProjectHeroImageApiProjectsProjectIdHeroImagePostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Upload Project Hero Image
 */
export const useUploadProjectHeroImageApiProjectsProjectIdHeroImagePost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadProjectHeroImageApiProjectsProjectIdHeroImagePost>>, TError,{projectId: string;data: BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadProjectHeroImageApiProjectsProjectIdHeroImagePost>>,
        TError,
        {projectId: string;data: BodyUploadProjectHeroImageApiProjectsProjectIdHeroImagePost},
        TContext
      > => {

      const mutationOptions = getUploadProjectHeroImageApiProjectsProjectIdHeroImagePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remove the project thumbnail.
 * @summary Delete Project Hero Image
 */
export const deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/projects/${projectId}/hero-image`,options
    );
  }



export const getDeleteProjectHeroImageApiProjectsProjectIdHeroImageDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete(projectId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectHeroImageApiProjectsProjectIdHeroImageDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete>>>
    
    export type DeleteProjectHeroImageApiProjectsProjectIdHeroImageDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Project Hero Image
 */
export const useDeleteProjectHeroImageApiProjectsProjectIdHeroImageDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectHeroImageApiProjectsProjectIdHeroImageDelete>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getDeleteProjectHeroImageApiProjectsProjectIdHeroImageDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read Project
 */
export const readProjectApiProjectsProjectIdGet = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectWithFullData>> => {
    
    
    return axios.default.get(
      `/api/projects/${projectId}`,options
    );
  }




export const getReadProjectApiProjectsProjectIdGetQueryKey = (projectId?: string,) => {
    return [
    `/api/projects/${projectId}`
    ] as const;
    }

    
export const getReadProjectApiProjectsProjectIdGetQueryOptions = <TData = Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError = AxiosError<HTTPValidationError>>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadProjectApiProjectsProjectIdGetQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>> = ({ signal }) => readProjectApiProjectsProjectIdGet(projectId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadProjectApiProjectsProjectIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>>
export type ReadProjectApiProjectsProjectIdGetQueryError = AxiosError<HTTPValidationError>


export function useReadProjectApiProjectsProjectIdGet<TData = Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>,
          TError,
          Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadProjectApiProjectsProjectIdGet<TData = Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>,
          TError,
          Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadProjectApiProjectsProjectIdGet<TData = Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Project
 */

export function useReadProjectApiProjectsProjectIdGet<TData = Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readProjectApiProjectsProjectIdGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadProjectApiProjectsProjectIdGetQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update Project
 */
export const updateProjectApiProjectsProjectIdPut = (
    projectId: string,
    projectUpdate: ProjectUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectWithClient>> => {
    
    
    return axios.default.put(
      `/api/projects/${projectId}`,
      projectUpdate,options
    );
  }



export const getUpdateProjectApiProjectsProjectIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectApiProjectsProjectIdPut>>, TError,{projectId: string;data: ProjectUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectApiProjectsProjectIdPut>>, TError,{projectId: string;data: ProjectUpdate}, TContext> => {

const mutationKey = ['updateProjectApiProjectsProjectIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectApiProjectsProjectIdPut>>, {projectId: string;data: ProjectUpdate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  updateProjectApiProjectsProjectIdPut(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectApiProjectsProjectIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectApiProjectsProjectIdPut>>>
    export type UpdateProjectApiProjectsProjectIdPutMutationBody = ProjectUpdate
    export type UpdateProjectApiProjectsProjectIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Project
 */
export const useUpdateProjectApiProjectsProjectIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectApiProjectsProjectIdPut>>, TError,{projectId: string;data: ProjectUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectApiProjectsProjectIdPut>>,
        TError,
        {projectId: string;data: ProjectUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateProjectApiProjectsProjectIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Project
 */
export const deleteProjectApiProjectsProjectIdDelete = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/projects/${projectId}`,options
    );
  }



export const getDeleteProjectApiProjectsProjectIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectApiProjectsProjectIdDelete>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectApiProjectsProjectIdDelete>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['deleteProjectApiProjectsProjectIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectApiProjectsProjectIdDelete>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  deleteProjectApiProjectsProjectIdDelete(projectId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectApiProjectsProjectIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectApiProjectsProjectIdDelete>>>
    
    export type DeleteProjectApiProjectsProjectIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Project
 */
export const useDeleteProjectApiProjectsProjectIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectApiProjectsProjectIdDelete>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectApiProjectsProjectIdDelete>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getDeleteProjectApiProjectsProjectIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Return the project's public view link, creating one if it does not exist.
 * @summary Generate Share Token
 */
export const generateShareTokenApiProjectsProjectIdSharePost = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectShareResponse>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/share`,undefined,options
    );
  }



export const getGenerateShareTokenApiProjectsProjectIdSharePostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateShareTokenApiProjectsProjectIdSharePost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof generateShareTokenApiProjectsProjectIdSharePost>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['generateShareTokenApiProjectsProjectIdSharePost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateShareTokenApiProjectsProjectIdSharePost>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  generateShareTokenApiProjectsProjectIdSharePost(projectId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateShareTokenApiProjectsProjectIdSharePostMutationResult = NonNullable<Awaited<ReturnType<typeof generateShareTokenApiProjectsProjectIdSharePost>>>
    
    export type GenerateShareTokenApiProjectsProjectIdSharePostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Generate Share Token
 */
export const useGenerateShareTokenApiProjectsProjectIdSharePost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateShareTokenApiProjectsProjectIdSharePost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateShareTokenApiProjectsProjectIdSharePost>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getGenerateShareTokenApiProjectsProjectIdSharePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Revoke the public share token for the project.
 * @summary Revoke Share Token
 */
export const revokeShareTokenApiProjectsProjectIdShareDelete = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/projects/${projectId}/share`,options
    );
  }



export const getRevokeShareTokenApiProjectsProjectIdShareDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeShareTokenApiProjectsProjectIdShareDelete>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof revokeShareTokenApiProjectsProjectIdShareDelete>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['revokeShareTokenApiProjectsProjectIdShareDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeShareTokenApiProjectsProjectIdShareDelete>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  revokeShareTokenApiProjectsProjectIdShareDelete(projectId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeShareTokenApiProjectsProjectIdShareDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof revokeShareTokenApiProjectsProjectIdShareDelete>>>
    
    export type RevokeShareTokenApiProjectsProjectIdShareDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Revoke Share Token
 */
export const useRevokeShareTokenApiProjectsProjectIdShareDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeShareTokenApiProjectsProjectIdShareDelete>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeShareTokenApiProjectsProjectIdShareDelete>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getRevokeShareTokenApiProjectsProjectIdShareDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Record that the current user is viewing the project and return active viewers.
 * @summary Heartbeat Project Presence
 */
export const heartbeatProjectPresenceApiProjectsProjectIdPresencePost = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectPresenceResponse>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/presence`,undefined,options
    );
  }



export const getHeartbeatProjectPresenceApiProjectsProjectIdPresencePostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof heartbeatProjectPresenceApiProjectsProjectIdPresencePost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof heartbeatProjectPresenceApiProjectsProjectIdPresencePost>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['heartbeatProjectPresenceApiProjectsProjectIdPresencePost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof heartbeatProjectPresenceApiProjectsProjectIdPresencePost>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  heartbeatProjectPresenceApiProjectsProjectIdPresencePost(projectId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HeartbeatProjectPresenceApiProjectsProjectIdPresencePostMutationResult = NonNullable<Awaited<ReturnType<typeof heartbeatProjectPresenceApiProjectsProjectIdPresencePost>>>
    
    export type HeartbeatProjectPresenceApiProjectsProjectIdPresencePostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Heartbeat Project Presence
 */
export const useHeartbeatProjectPresenceApiProjectsProjectIdPresencePost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof heartbeatProjectPresenceApiProjectsProjectIdPresencePost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof heartbeatProjectPresenceApiProjectsProjectIdPresencePost>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getHeartbeatProjectPresenceApiProjectsProjectIdPresencePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Invite a person by email to edit this project.
 * @summary Invite Project Collaborator
 */
export const inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost = (
    projectId: string,
    projectCollaboratorInvite: ProjectCollaboratorInvite, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectCollaboratorOut>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/collaborators`,
      projectCollaboratorInvite,options
    );
  }



export const getInviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost>>, TError,{projectId: string;data: ProjectCollaboratorInvite}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost>>, TError,{projectId: string;data: ProjectCollaboratorInvite}, TContext> => {

const mutationKey = ['inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost>>, {projectId: string;data: ProjectCollaboratorInvite}> = (props) => {
          const {projectId,data} = props ?? {};

          return  inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPostMutationResult = NonNullable<Awaited<ReturnType<typeof inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost>>>
    export type InviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPostMutationBody = ProjectCollaboratorInvite
    export type InviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Invite Project Collaborator
 */
export const useInviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost>>, TError,{projectId: string;data: ProjectCollaboratorInvite}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPost>>,
        TError,
        {projectId: string;data: ProjectCollaboratorInvite},
        TContext
      > => {

      const mutationOptions = getInviteProjectCollaboratorApiProjectsProjectIdCollaboratorsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remove a collaborator's edit access.
 * @summary Remove Project Collaborator
 */
export const removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete = (
    projectId: string,
    collaboratorId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/projects/${projectId}/collaborators/${collaboratorId}`,options
    );
  }



export const getRemoveProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete>>, TError,{projectId: string;collaboratorId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete>>, TError,{projectId: string;collaboratorId: string}, TContext> => {

const mutationKey = ['removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete>>, {projectId: string;collaboratorId: string}> = (props) => {
          const {projectId,collaboratorId} = props ?? {};

          return  removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete(projectId,collaboratorId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete>>>
    
    export type RemoveProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Remove Project Collaborator
 */
export const useRemoveProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete>>, TError,{projectId: string;collaboratorId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDelete>>,
        TError,
        {projectId: string;collaboratorId: string},
        TContext
      > => {

      const mutationOptions = getRemoveProjectCollaboratorApiProjectsProjectIdCollaboratorsCollaboratorIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read Contacts
 */
export const readContactsApiContactsGet = (
    params?: ReadContactsApiContactsGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PaginatedResponseContact>> => {
    
    
    return axios.default.get(
      `/api/contacts/`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getReadContactsApiContactsGetQueryKey = (params?: ReadContactsApiContactsGetParams,) => {
    return [
    `/api/contacts/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReadContactsApiContactsGetQueryOptions = <TData = Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError = AxiosError<HTTPValidationError>>(params?: ReadContactsApiContactsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadContactsApiContactsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readContactsApiContactsGet>>> = ({ signal }) => readContactsApiContactsGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadContactsApiContactsGetQueryResult = NonNullable<Awaited<ReturnType<typeof readContactsApiContactsGet>>>
export type ReadContactsApiContactsGetQueryError = AxiosError<HTTPValidationError>


export function useReadContactsApiContactsGet<TData = Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError = AxiosError<HTTPValidationError>>(
 params: undefined |  ReadContactsApiContactsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readContactsApiContactsGet>>,
          TError,
          Awaited<ReturnType<typeof readContactsApiContactsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadContactsApiContactsGet<TData = Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadContactsApiContactsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readContactsApiContactsGet>>,
          TError,
          Awaited<ReturnType<typeof readContactsApiContactsGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadContactsApiContactsGet<TData = Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadContactsApiContactsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Contacts
 */

export function useReadContactsApiContactsGet<TData = Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError = AxiosError<HTTPValidationError>>(
 params?: ReadContactsApiContactsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readContactsApiContactsGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadContactsApiContactsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create Contact
 */
export const createContactApiContactsPost = (
    contactCreate: ContactCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Contact>> => {
    
    
    return axios.default.post(
      `/api/contacts/`,
      contactCreate,options
    );
  }



export const getCreateContactApiContactsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactApiContactsPost>>, TError,{data: ContactCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createContactApiContactsPost>>, TError,{data: ContactCreate}, TContext> => {

const mutationKey = ['createContactApiContactsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContactApiContactsPost>>, {data: ContactCreate}> = (props) => {
          const {data} = props ?? {};

          return  createContactApiContactsPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateContactApiContactsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createContactApiContactsPost>>>
    export type CreateContactApiContactsPostMutationBody = ContactCreate
    export type CreateContactApiContactsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Contact
 */
export const useCreateContactApiContactsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactApiContactsPost>>, TError,{data: ContactCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContactApiContactsPost>>,
        TError,
        {data: ContactCreate},
        TContext
      > => {

      const mutationOptions = getCreateContactApiContactsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Import Contacts
 */
export const importContactsApiContactsImportPost = (
    bodyImportContactsApiContactsImportPost: BodyImportContactsApiContactsImportPost, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ContactImportResult>> => {
    
    const formData = new FormData();
formData.append(`file`, bodyImportContactsApiContactsImportPost.file)

    return axios.default.post(
      `/api/contacts/import`,
      formData,options
    );
  }



export const getImportContactsApiContactsImportPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importContactsApiContactsImportPost>>, TError,{data: BodyImportContactsApiContactsImportPost}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importContactsApiContactsImportPost>>, TError,{data: BodyImportContactsApiContactsImportPost}, TContext> => {

const mutationKey = ['importContactsApiContactsImportPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importContactsApiContactsImportPost>>, {data: BodyImportContactsApiContactsImportPost}> = (props) => {
          const {data} = props ?? {};

          return  importContactsApiContactsImportPost(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportContactsApiContactsImportPostMutationResult = NonNullable<Awaited<ReturnType<typeof importContactsApiContactsImportPost>>>
    export type ImportContactsApiContactsImportPostMutationBody = BodyImportContactsApiContactsImportPost
    export type ImportContactsApiContactsImportPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Import Contacts
 */
export const useImportContactsApiContactsImportPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importContactsApiContactsImportPost>>, TError,{data: BodyImportContactsApiContactsImportPost}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importContactsApiContactsImportPost>>,
        TError,
        {data: BodyImportContactsApiContactsImportPost},
        TContext
      > => {

      const mutationOptions = getImportContactsApiContactsImportPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Contact
 */
export const updateContactApiContactsContactIdPut = (
    contactId: string,
    contactUpdate: ContactUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Contact>> => {
    
    
    return axios.default.put(
      `/api/contacts/${contactId}`,
      contactUpdate,options
    );
  }



export const getUpdateContactApiContactsContactIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactApiContactsContactIdPut>>, TError,{contactId: string;data: ContactUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateContactApiContactsContactIdPut>>, TError,{contactId: string;data: ContactUpdate}, TContext> => {

const mutationKey = ['updateContactApiContactsContactIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactApiContactsContactIdPut>>, {contactId: string;data: ContactUpdate}> = (props) => {
          const {contactId,data} = props ?? {};

          return  updateContactApiContactsContactIdPut(contactId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactApiContactsContactIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactApiContactsContactIdPut>>>
    export type UpdateContactApiContactsContactIdPutMutationBody = ContactUpdate
    export type UpdateContactApiContactsContactIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Contact
 */
export const useUpdateContactApiContactsContactIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactApiContactsContactIdPut>>, TError,{contactId: string;data: ContactUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContactApiContactsContactIdPut>>,
        TError,
        {contactId: string;data: ContactUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateContactApiContactsContactIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Contact
 */
export const deleteContactApiContactsContactIdDelete = (
    contactId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/contacts/${contactId}`,options
    );
  }



export const getDeleteContactApiContactsContactIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactApiContactsContactIdDelete>>, TError,{contactId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContactApiContactsContactIdDelete>>, TError,{contactId: string}, TContext> => {

const mutationKey = ['deleteContactApiContactsContactIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactApiContactsContactIdDelete>>, {contactId: string}> = (props) => {
          const {contactId} = props ?? {};

          return  deleteContactApiContactsContactIdDelete(contactId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactApiContactsContactIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactApiContactsContactIdDelete>>>
    
    export type DeleteContactApiContactsContactIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Contact
 */
export const useDeleteContactApiContactsContactIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactApiContactsContactIdDelete>>, TError,{contactId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContactApiContactsContactIdDelete>>,
        TError,
        {contactId: string},
        TContext
      > => {

      const mutationOptions = getDeleteContactApiContactsContactIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Create Shotlist
 */
export const createShotlistApiProjectsProjectIdShotlistsPost = (
    projectId: string,
    shotlistCreate: ShotlistCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Shotlist>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/shotlists`,
      shotlistCreate,options
    );
  }



export const getCreateShotlistApiProjectsProjectIdShotlistsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShotlistApiProjectsProjectIdShotlistsPost>>, TError,{projectId: string;data: ShotlistCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createShotlistApiProjectsProjectIdShotlistsPost>>, TError,{projectId: string;data: ShotlistCreate}, TContext> => {

const mutationKey = ['createShotlistApiProjectsProjectIdShotlistsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShotlistApiProjectsProjectIdShotlistsPost>>, {projectId: string;data: ShotlistCreate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createShotlistApiProjectsProjectIdShotlistsPost(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateShotlistApiProjectsProjectIdShotlistsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createShotlistApiProjectsProjectIdShotlistsPost>>>
    export type CreateShotlistApiProjectsProjectIdShotlistsPostMutationBody = ShotlistCreate
    export type CreateShotlistApiProjectsProjectIdShotlistsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Shotlist
 */
export const useCreateShotlistApiProjectsProjectIdShotlistsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShotlistApiProjectsProjectIdShotlistsPost>>, TError,{projectId: string;data: ShotlistCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createShotlistApiProjectsProjectIdShotlistsPost>>,
        TError,
        {projectId: string;data: ShotlistCreate},
        TContext
      > => {

      const mutationOptions = getCreateShotlistApiProjectsProjectIdShotlistsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Shotlist
 */
export const updateShotlistApiShotlistsShotlistIdPut = (
    shotlistId: string,
    shotlistUpdate: ShotlistUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Shotlist>> => {
    
    
    return axios.default.put(
      `/api/shotlists/${shotlistId}`,
      shotlistUpdate,options
    );
  }



export const getUpdateShotlistApiShotlistsShotlistIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShotlistApiShotlistsShotlistIdPut>>, TError,{shotlistId: string;data: ShotlistUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateShotlistApiShotlistsShotlistIdPut>>, TError,{shotlistId: string;data: ShotlistUpdate}, TContext> => {

const mutationKey = ['updateShotlistApiShotlistsShotlistIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShotlistApiShotlistsShotlistIdPut>>, {shotlistId: string;data: ShotlistUpdate}> = (props) => {
          const {shotlistId,data} = props ?? {};

          return  updateShotlistApiShotlistsShotlistIdPut(shotlistId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateShotlistApiShotlistsShotlistIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateShotlistApiShotlistsShotlistIdPut>>>
    export type UpdateShotlistApiShotlistsShotlistIdPutMutationBody = ShotlistUpdate
    export type UpdateShotlistApiShotlistsShotlistIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Shotlist
 */
export const useUpdateShotlistApiShotlistsShotlistIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShotlistApiShotlistsShotlistIdPut>>, TError,{shotlistId: string;data: ShotlistUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateShotlistApiShotlistsShotlistIdPut>>,
        TError,
        {shotlistId: string;data: ShotlistUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateShotlistApiShotlistsShotlistIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Shotlist
 */
export const deleteShotlistApiShotlistsShotlistIdDelete = (
    shotlistId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/shotlists/${shotlistId}`,options
    );
  }



export const getDeleteShotlistApiShotlistsShotlistIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShotlistApiShotlistsShotlistIdDelete>>, TError,{shotlistId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShotlistApiShotlistsShotlistIdDelete>>, TError,{shotlistId: string}, TContext> => {

const mutationKey = ['deleteShotlistApiShotlistsShotlistIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShotlistApiShotlistsShotlistIdDelete>>, {shotlistId: string}> = (props) => {
          const {shotlistId} = props ?? {};

          return  deleteShotlistApiShotlistsShotlistIdDelete(shotlistId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteShotlistApiShotlistsShotlistIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShotlistApiShotlistsShotlistIdDelete>>>
    
    export type DeleteShotlistApiShotlistsShotlistIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Shotlist
 */
export const useDeleteShotlistApiShotlistsShotlistIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShotlistApiShotlistsShotlistIdDelete>>, TError,{shotlistId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteShotlistApiShotlistsShotlistIdDelete>>,
        TError,
        {shotlistId: string},
        TContext
      > => {

      const mutationOptions = getDeleteShotlistApiShotlistsShotlistIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Create Shotlist Item
 */
export const createShotlistItemApiShotlistsShotlistIdItemsPost = (
    shotlistId: string,
    shotlistItemCreate: ShotlistItemCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShotlistItem>> => {
    
    
    return axios.default.post(
      `/api/shotlists/${shotlistId}/items`,
      shotlistItemCreate,options
    );
  }



export const getCreateShotlistItemApiShotlistsShotlistIdItemsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShotlistItemApiShotlistsShotlistIdItemsPost>>, TError,{shotlistId: string;data: ShotlistItemCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createShotlistItemApiShotlistsShotlistIdItemsPost>>, TError,{shotlistId: string;data: ShotlistItemCreate}, TContext> => {

const mutationKey = ['createShotlistItemApiShotlistsShotlistIdItemsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShotlistItemApiShotlistsShotlistIdItemsPost>>, {shotlistId: string;data: ShotlistItemCreate}> = (props) => {
          const {shotlistId,data} = props ?? {};

          return  createShotlistItemApiShotlistsShotlistIdItemsPost(shotlistId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateShotlistItemApiShotlistsShotlistIdItemsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createShotlistItemApiShotlistsShotlistIdItemsPost>>>
    export type CreateShotlistItemApiShotlistsShotlistIdItemsPostMutationBody = ShotlistItemCreate
    export type CreateShotlistItemApiShotlistsShotlistIdItemsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Shotlist Item
 */
export const useCreateShotlistItemApiShotlistsShotlistIdItemsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShotlistItemApiShotlistsShotlistIdItemsPost>>, TError,{shotlistId: string;data: ShotlistItemCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createShotlistItemApiShotlistsShotlistIdItemsPost>>,
        TError,
        {shotlistId: string;data: ShotlistItemCreate},
        TContext
      > => {

      const mutationOptions = getCreateShotlistItemApiShotlistsShotlistIdItemsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Shotlist Item
 */
export const updateShotlistItemApiShotlistItemsItemIdPut = (
    itemId: string,
    shotlistItemUpdate: ShotlistItemUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShotlistItem>> => {
    
    
    return axios.default.put(
      `/api/shotlist-items/${itemId}`,
      shotlistItemUpdate,options
    );
  }



export const getUpdateShotlistItemApiShotlistItemsItemIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShotlistItemApiShotlistItemsItemIdPut>>, TError,{itemId: string;data: ShotlistItemUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateShotlistItemApiShotlistItemsItemIdPut>>, TError,{itemId: string;data: ShotlistItemUpdate}, TContext> => {

const mutationKey = ['updateShotlistItemApiShotlistItemsItemIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShotlistItemApiShotlistItemsItemIdPut>>, {itemId: string;data: ShotlistItemUpdate}> = (props) => {
          const {itemId,data} = props ?? {};

          return  updateShotlistItemApiShotlistItemsItemIdPut(itemId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateShotlistItemApiShotlistItemsItemIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateShotlistItemApiShotlistItemsItemIdPut>>>
    export type UpdateShotlistItemApiShotlistItemsItemIdPutMutationBody = ShotlistItemUpdate
    export type UpdateShotlistItemApiShotlistItemsItemIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Shotlist Item
 */
export const useUpdateShotlistItemApiShotlistItemsItemIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShotlistItemApiShotlistItemsItemIdPut>>, TError,{itemId: string;data: ShotlistItemUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateShotlistItemApiShotlistItemsItemIdPut>>,
        TError,
        {itemId: string;data: ShotlistItemUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateShotlistItemApiShotlistItemsItemIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Shotlist Item
 */
export const deleteShotlistItemApiShotlistItemsItemIdDelete = (
    itemId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/shotlist-items/${itemId}`,options
    );
  }



export const getDeleteShotlistItemApiShotlistItemsItemIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShotlistItemApiShotlistItemsItemIdDelete>>, TError,{itemId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShotlistItemApiShotlistItemsItemIdDelete>>, TError,{itemId: string}, TContext> => {

const mutationKey = ['deleteShotlistItemApiShotlistItemsItemIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShotlistItemApiShotlistItemsItemIdDelete>>, {itemId: string}> = (props) => {
          const {itemId} = props ?? {};

          return  deleteShotlistItemApiShotlistItemsItemIdDelete(itemId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteShotlistItemApiShotlistItemsItemIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShotlistItemApiShotlistItemsItemIdDelete>>>
    
    export type DeleteShotlistItemApiShotlistItemsItemIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Shotlist Item
 */
export const useDeleteShotlistItemApiShotlistItemsItemIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShotlistItemApiShotlistItemsItemIdDelete>>, TError,{itemId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteShotlistItemApiShotlistItemsItemIdDelete>>,
        TError,
        {itemId: string},
        TContext
      > => {

      const mutationOptions = getDeleteShotlistItemApiShotlistItemsItemIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Reorder Shotlist Items
 */
export const reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut = (
    shotlistId: string,
    reorderRequest: ReorderRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShotlistItem[]>> => {
    
    
    return axios.default.put(
      `/api/shotlists/${shotlistId}/items/reorder`,
      reorderRequest,options
    );
  }



export const getReorderShotlistItemsApiShotlistsShotlistIdItemsReorderPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut>>, TError,{shotlistId: string;data: ReorderRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut>>, TError,{shotlistId: string;data: ReorderRequest}, TContext> => {

const mutationKey = ['reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut>>, {shotlistId: string;data: ReorderRequest}> = (props) => {
          const {shotlistId,data} = props ?? {};

          return  reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut(shotlistId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReorderShotlistItemsApiShotlistsShotlistIdItemsReorderPutMutationResult = NonNullable<Awaited<ReturnType<typeof reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut>>>
    export type ReorderShotlistItemsApiShotlistsShotlistIdItemsReorderPutMutationBody = ReorderRequest
    export type ReorderShotlistItemsApiShotlistsShotlistIdItemsReorderPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Reorder Shotlist Items
 */
export const useReorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut>>, TError,{shotlistId: string;data: ReorderRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderShotlistItemsApiShotlistsShotlistIdItemsReorderPut>>,
        TError,
        {shotlistId: string;data: ReorderRequest},
        TContext
      > => {

      const mutationOptions = getReorderShotlistItemsApiShotlistsShotlistIdItemsReorderPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Batch Update Shotlist Items
 */
export const batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut = (
    shotlistId: string,
    shotlistItemBatchUpdate: ShotlistItemBatchUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShotlistItem[]>> => {
    
    
    return axios.default.put(
      `/api/shotlists/${shotlistId}/items/batch`,
      shotlistItemBatchUpdate,options
    );
  }



export const getBatchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut>>, TError,{shotlistId: string;data: ShotlistItemBatchUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut>>, TError,{shotlistId: string;data: ShotlistItemBatchUpdate}, TContext> => {

const mutationKey = ['batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut>>, {shotlistId: string;data: ShotlistItemBatchUpdate}> = (props) => {
          const {shotlistId,data} = props ?? {};

          return  batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut(shotlistId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BatchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPutMutationResult = NonNullable<Awaited<ReturnType<typeof batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut>>>
    export type BatchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPutMutationBody = ShotlistItemBatchUpdate
    export type BatchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Batch Update Shotlist Items
 */
export const useBatchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut>>, TError,{shotlistId: string;data: ShotlistItemBatchUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPut>>,
        TError,
        {shotlistId: string;data: ShotlistItemBatchUpdate},
        TContext
      > => {

      const mutationOptions = getBatchUpdateShotlistItemsApiShotlistsShotlistIdItemsBatchPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Image
 */
export const deleteImageApiShotlistItemsItemIdImagesImageIndexDelete = (
    itemId: string,
    imageIndex: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/shotlist-items/${itemId}/images/${imageIndex}`,options
    );
  }



export const getDeleteImageApiShotlistItemsItemIdImagesImageIndexDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageApiShotlistItemsItemIdImagesImageIndexDelete>>, TError,{itemId: string;imageIndex: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImageApiShotlistItemsItemIdImagesImageIndexDelete>>, TError,{itemId: string;imageIndex: number}, TContext> => {

const mutationKey = ['deleteImageApiShotlistItemsItemIdImagesImageIndexDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImageApiShotlistItemsItemIdImagesImageIndexDelete>>, {itemId: string;imageIndex: number}> = (props) => {
          const {itemId,imageIndex} = props ?? {};

          return  deleteImageApiShotlistItemsItemIdImagesImageIndexDelete(itemId,imageIndex,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteImageApiShotlistItemsItemIdImagesImageIndexDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImageApiShotlistItemsItemIdImagesImageIndexDelete>>>
    
    export type DeleteImageApiShotlistItemsItemIdImagesImageIndexDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Image
 */
export const useDeleteImageApiShotlistItemsItemIdImagesImageIndexDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageApiShotlistItemsItemIdImagesImageIndexDelete>>, TError,{itemId: string;imageIndex: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteImageApiShotlistItemsItemIdImagesImageIndexDelete>>,
        TError,
        {itemId: string;imageIndex: number},
        TContext
      > => {

      const mutationOptions = getDeleteImageApiShotlistItemsItemIdImagesImageIndexDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Upload Image
 */
export const uploadImageApiShotlistItemsItemIdUploadImagePost = (
    itemId: string,
    bodyUploadImageApiShotlistItemsItemIdUploadImagePost: BodyUploadImageApiShotlistItemsItemIdUploadImagePost, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImageResponse>> => {
    
    const formData = new FormData();
formData.append(`file`, bodyUploadImageApiShotlistItemsItemIdUploadImagePost.file)

    return axios.default.post(
      `/api/shotlist-items/${itemId}/upload-image`,
      formData,options
    );
  }



export const getUploadImageApiShotlistItemsItemIdUploadImagePostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImageApiShotlistItemsItemIdUploadImagePost>>, TError,{itemId: string;data: BodyUploadImageApiShotlistItemsItemIdUploadImagePost}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImageApiShotlistItemsItemIdUploadImagePost>>, TError,{itemId: string;data: BodyUploadImageApiShotlistItemsItemIdUploadImagePost}, TContext> => {

const mutationKey = ['uploadImageApiShotlistItemsItemIdUploadImagePost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImageApiShotlistItemsItemIdUploadImagePost>>, {itemId: string;data: BodyUploadImageApiShotlistItemsItemIdUploadImagePost}> = (props) => {
          const {itemId,data} = props ?? {};

          return  uploadImageApiShotlistItemsItemIdUploadImagePost(itemId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadImageApiShotlistItemsItemIdUploadImagePostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImageApiShotlistItemsItemIdUploadImagePost>>>
    export type UploadImageApiShotlistItemsItemIdUploadImagePostMutationBody = BodyUploadImageApiShotlistItemsItemIdUploadImagePost
    export type UploadImageApiShotlistItemsItemIdUploadImagePostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Upload Image
 */
export const useUploadImageApiShotlistItemsItemIdUploadImagePost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImageApiShotlistItemsItemIdUploadImagePost>>, TError,{itemId: string;data: BodyUploadImageApiShotlistItemsItemIdUploadImagePost}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadImageApiShotlistItemsItemIdUploadImagePost>>,
        TError,
        {itemId: string;data: BodyUploadImageApiShotlistItemsItemIdUploadImagePost},
        TContext
      > => {

      const mutationOptions = getUploadImageApiShotlistItemsItemIdUploadImagePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Read Shoot Members
 */
export const readShootMembersApiProjectsProjectIdShootMembersGet = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShootMember[]>> => {
    
    
    return axios.default.get(
      `/api/projects/${projectId}/shoot-members`,options
    );
  }




export const getReadShootMembersApiProjectsProjectIdShootMembersGetQueryKey = (projectId?: string,) => {
    return [
    `/api/projects/${projectId}/shoot-members`
    ] as const;
    }

    
export const getReadShootMembersApiProjectsProjectIdShootMembersGetQueryOptions = <TData = Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError = AxiosError<HTTPValidationError>>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadShootMembersApiProjectsProjectIdShootMembersGetQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>> = ({ signal }) => readShootMembersApiProjectsProjectIdShootMembersGet(projectId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadShootMembersApiProjectsProjectIdShootMembersGetQueryResult = NonNullable<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>>
export type ReadShootMembersApiProjectsProjectIdShootMembersGetQueryError = AxiosError<HTTPValidationError>


export function useReadShootMembersApiProjectsProjectIdShootMembersGet<TData = Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>,
          TError,
          Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadShootMembersApiProjectsProjectIdShootMembersGet<TData = Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>,
          TError,
          Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadShootMembersApiProjectsProjectIdShootMembersGet<TData = Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Shoot Members
 */

export function useReadShootMembersApiProjectsProjectIdShootMembersGet<TData = Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError = AxiosError<HTTPValidationError>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readShootMembersApiProjectsProjectIdShootMembersGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadShootMembersApiProjectsProjectIdShootMembersGetQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create Shoot Member
 */
export const createShootMemberApiProjectsProjectIdShootMembersPost = (
    projectId: string,
    shootMemberCreate: ShootMemberCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShootMember>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/shoot-members`,
      shootMemberCreate,options
    );
  }



export const getCreateShootMemberApiProjectsProjectIdShootMembersPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShootMemberApiProjectsProjectIdShootMembersPost>>, TError,{projectId: string;data: ShootMemberCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createShootMemberApiProjectsProjectIdShootMembersPost>>, TError,{projectId: string;data: ShootMemberCreate}, TContext> => {

const mutationKey = ['createShootMemberApiProjectsProjectIdShootMembersPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShootMemberApiProjectsProjectIdShootMembersPost>>, {projectId: string;data: ShootMemberCreate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createShootMemberApiProjectsProjectIdShootMembersPost(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateShootMemberApiProjectsProjectIdShootMembersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createShootMemberApiProjectsProjectIdShootMembersPost>>>
    export type CreateShootMemberApiProjectsProjectIdShootMembersPostMutationBody = ShootMemberCreate
    export type CreateShootMemberApiProjectsProjectIdShootMembersPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Shoot Member
 */
export const useCreateShootMemberApiProjectsProjectIdShootMembersPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShootMemberApiProjectsProjectIdShootMembersPost>>, TError,{projectId: string;data: ShootMemberCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createShootMemberApiProjectsProjectIdShootMembersPost>>,
        TError,
        {projectId: string;data: ShootMemberCreate},
        TContext
      > => {

      const mutationOptions = getCreateShootMemberApiProjectsProjectIdShootMembersPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Shoot Member
 */
export const updateShootMemberApiShootMembersMemberIdPut = (
    memberId: string,
    shootMemberUpdate: ShootMemberUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShootMember>> => {
    
    
    return axios.default.put(
      `/api/shoot-members/${memberId}`,
      shootMemberUpdate,options
    );
  }



export const getUpdateShootMemberApiShootMembersMemberIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShootMemberApiShootMembersMemberIdPut>>, TError,{memberId: string;data: ShootMemberUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateShootMemberApiShootMembersMemberIdPut>>, TError,{memberId: string;data: ShootMemberUpdate}, TContext> => {

const mutationKey = ['updateShootMemberApiShootMembersMemberIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShootMemberApiShootMembersMemberIdPut>>, {memberId: string;data: ShootMemberUpdate}> = (props) => {
          const {memberId,data} = props ?? {};

          return  updateShootMemberApiShootMembersMemberIdPut(memberId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateShootMemberApiShootMembersMemberIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateShootMemberApiShootMembersMemberIdPut>>>
    export type UpdateShootMemberApiShootMembersMemberIdPutMutationBody = ShootMemberUpdate
    export type UpdateShootMemberApiShootMembersMemberIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Shoot Member
 */
export const useUpdateShootMemberApiShootMembersMemberIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShootMemberApiShootMembersMemberIdPut>>, TError,{memberId: string;data: ShootMemberUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateShootMemberApiShootMembersMemberIdPut>>,
        TError,
        {memberId: string;data: ShootMemberUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateShootMemberApiShootMembersMemberIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Shoot Member
 */
export const deleteShootMemberApiShootMembersMemberIdDelete = (
    memberId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/shoot-members/${memberId}`,options
    );
  }



export const getDeleteShootMemberApiShootMembersMemberIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShootMemberApiShootMembersMemberIdDelete>>, TError,{memberId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShootMemberApiShootMembersMemberIdDelete>>, TError,{memberId: string}, TContext> => {

const mutationKey = ['deleteShootMemberApiShootMembersMemberIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShootMemberApiShootMembersMemberIdDelete>>, {memberId: string}> = (props) => {
          const {memberId} = props ?? {};

          return  deleteShootMemberApiShootMembersMemberIdDelete(memberId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteShootMemberApiShootMembersMemberIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShootMemberApiShootMembersMemberIdDelete>>>
    
    export type DeleteShootMemberApiShootMembersMemberIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Shoot Member
 */
export const useDeleteShootMemberApiShootMembersMemberIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShootMemberApiShootMembersMemberIdDelete>>, TError,{memberId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteShootMemberApiShootMembersMemberIdDelete>>,
        TError,
        {memberId: string},
        TContext
      > => {

      const mutationOptions = getDeleteShootMemberApiShootMembersMemberIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a new lunch order for a shotlist item.
 * @summary Create Lunch Order
 */
export const createLunchOrderApiShotlistItemsItemIdLunchOrdersPost = (
    itemId: string,
    lunchOrderCreate: LunchOrderCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LunchOrder>> => {
    
    
    return axios.default.post(
      `/api/shotlist-items/${itemId}/lunch-orders`,
      lunchOrderCreate,options
    );
  }



export const getCreateLunchOrderApiShotlistItemsItemIdLunchOrdersPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLunchOrderApiShotlistItemsItemIdLunchOrdersPost>>, TError,{itemId: string;data: LunchOrderCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createLunchOrderApiShotlistItemsItemIdLunchOrdersPost>>, TError,{itemId: string;data: LunchOrderCreate}, TContext> => {

const mutationKey = ['createLunchOrderApiShotlistItemsItemIdLunchOrdersPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLunchOrderApiShotlistItemsItemIdLunchOrdersPost>>, {itemId: string;data: LunchOrderCreate}> = (props) => {
          const {itemId,data} = props ?? {};

          return  createLunchOrderApiShotlistItemsItemIdLunchOrdersPost(itemId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLunchOrderApiShotlistItemsItemIdLunchOrdersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createLunchOrderApiShotlistItemsItemIdLunchOrdersPost>>>
    export type CreateLunchOrderApiShotlistItemsItemIdLunchOrdersPostMutationBody = LunchOrderCreate
    export type CreateLunchOrderApiShotlistItemsItemIdLunchOrdersPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Lunch Order
 */
export const useCreateLunchOrderApiShotlistItemsItemIdLunchOrdersPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLunchOrderApiShotlistItemsItemIdLunchOrdersPost>>, TError,{itemId: string;data: LunchOrderCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLunchOrderApiShotlistItemsItemIdLunchOrdersPost>>,
        TError,
        {itemId: string;data: LunchOrderCreate},
        TContext
      > => {

      const mutationOptions = getCreateLunchOrderApiShotlistItemsItemIdLunchOrdersPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a lunch order. Logged-in users can update any order in their projects.
 * @summary Update Lunch Order
 */
export const updateLunchOrderApiLunchOrdersOrderIdPut = (
    orderId: string,
    lunchOrderUpdate: LunchOrderUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LunchOrder>> => {
    
    
    return axios.default.put(
      `/api/lunch-orders/${orderId}`,
      lunchOrderUpdate,options
    );
  }



export const getUpdateLunchOrderApiLunchOrdersOrderIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLunchOrderApiLunchOrdersOrderIdPut>>, TError,{orderId: string;data: LunchOrderUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateLunchOrderApiLunchOrdersOrderIdPut>>, TError,{orderId: string;data: LunchOrderUpdate}, TContext> => {

const mutationKey = ['updateLunchOrderApiLunchOrdersOrderIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLunchOrderApiLunchOrdersOrderIdPut>>, {orderId: string;data: LunchOrderUpdate}> = (props) => {
          const {orderId,data} = props ?? {};

          return  updateLunchOrderApiLunchOrdersOrderIdPut(orderId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLunchOrderApiLunchOrdersOrderIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateLunchOrderApiLunchOrdersOrderIdPut>>>
    export type UpdateLunchOrderApiLunchOrdersOrderIdPutMutationBody = LunchOrderUpdate
    export type UpdateLunchOrderApiLunchOrdersOrderIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Lunch Order
 */
export const useUpdateLunchOrderApiLunchOrdersOrderIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLunchOrderApiLunchOrdersOrderIdPut>>, TError,{orderId: string;data: LunchOrderUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLunchOrderApiLunchOrdersOrderIdPut>>,
        TError,
        {orderId: string;data: LunchOrderUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateLunchOrderApiLunchOrdersOrderIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a lunch order. Logged-in users can delete any order in their projects.
 * @summary Delete Lunch Order
 */
export const deleteLunchOrderApiLunchOrdersOrderIdDelete = (
    orderId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/lunch-orders/${orderId}`,options
    );
  }



export const getDeleteLunchOrderApiLunchOrdersOrderIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLunchOrderApiLunchOrdersOrderIdDelete>>, TError,{orderId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLunchOrderApiLunchOrdersOrderIdDelete>>, TError,{orderId: string}, TContext> => {

const mutationKey = ['deleteLunchOrderApiLunchOrdersOrderIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLunchOrderApiLunchOrdersOrderIdDelete>>, {orderId: string}> = (props) => {
          const {orderId} = props ?? {};

          return  deleteLunchOrderApiLunchOrdersOrderIdDelete(orderId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLunchOrderApiLunchOrdersOrderIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLunchOrderApiLunchOrdersOrderIdDelete>>>
    
    export type DeleteLunchOrderApiLunchOrdersOrderIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Lunch Order
 */
export const useDeleteLunchOrderApiLunchOrdersOrderIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLunchOrderApiLunchOrdersOrderIdDelete>>, TError,{orderId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLunchOrderApiLunchOrdersOrderIdDelete>>,
        TError,
        {orderId: string},
        TContext
      > => {

      const mutationOptions = getDeleteLunchOrderApiLunchOrdersOrderIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Create Document
 */
export const createDocumentApiProjectsProjectIdDocumentsPost = (
    projectId: string,
    projectDocumentCreate: ProjectDocumentCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectDocument>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/documents`,
      projectDocumentCreate,options
    );
  }



export const getCreateDocumentApiProjectsProjectIdDocumentsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentApiProjectsProjectIdDocumentsPost>>, TError,{projectId: string;data: ProjectDocumentCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentApiProjectsProjectIdDocumentsPost>>, TError,{projectId: string;data: ProjectDocumentCreate}, TContext> => {

const mutationKey = ['createDocumentApiProjectsProjectIdDocumentsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentApiProjectsProjectIdDocumentsPost>>, {projectId: string;data: ProjectDocumentCreate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createDocumentApiProjectsProjectIdDocumentsPost(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentApiProjectsProjectIdDocumentsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentApiProjectsProjectIdDocumentsPost>>>
    export type CreateDocumentApiProjectsProjectIdDocumentsPostMutationBody = ProjectDocumentCreate
    export type CreateDocumentApiProjectsProjectIdDocumentsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Document
 */
export const useCreateDocumentApiProjectsProjectIdDocumentsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentApiProjectsProjectIdDocumentsPost>>, TError,{projectId: string;data: ProjectDocumentCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDocumentApiProjectsProjectIdDocumentsPost>>,
        TError,
        {projectId: string;data: ProjectDocumentCreate},
        TContext
      > => {

      const mutationOptions = getCreateDocumentApiProjectsProjectIdDocumentsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Upload Document
 */
export const uploadDocumentApiProjectsProjectIdDocumentsUploadPost = (
    projectId: string,
    bodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost: BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectDocument>> => {
    
    const formData = new FormData();
formData.append(`file`, bodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost.file)
if(bodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost.title !== undefined) {
 formData.append(`title`, bodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost.title)
 }
if(bodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost.day_id !== undefined && bodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost.day_id !== null) {
 formData.append(`day_id`, bodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost.day_id)
 }

    return axios.default.post(
      `/api/projects/${projectId}/documents/upload`,
      formData,options
    );
  }



export const getUploadDocumentApiProjectsProjectIdDocumentsUploadPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentApiProjectsProjectIdDocumentsUploadPost>>, TError,{projectId: string;data: BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentApiProjectsProjectIdDocumentsUploadPost>>, TError,{projectId: string;data: BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost}, TContext> => {

const mutationKey = ['uploadDocumentApiProjectsProjectIdDocumentsUploadPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocumentApiProjectsProjectIdDocumentsUploadPost>>, {projectId: string;data: BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost}> = (props) => {
          const {projectId,data} = props ?? {};

          return  uploadDocumentApiProjectsProjectIdDocumentsUploadPost(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentApiProjectsProjectIdDocumentsUploadPostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocumentApiProjectsProjectIdDocumentsUploadPost>>>
    export type UploadDocumentApiProjectsProjectIdDocumentsUploadPostMutationBody = BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost
    export type UploadDocumentApiProjectsProjectIdDocumentsUploadPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Upload Document
 */
export const useUploadDocumentApiProjectsProjectIdDocumentsUploadPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentApiProjectsProjectIdDocumentsUploadPost>>, TError,{projectId: string;data: BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocumentApiProjectsProjectIdDocumentsUploadPost>>,
        TError,
        {projectId: string;data: BodyUploadDocumentApiProjectsProjectIdDocumentsUploadPost},
        TContext
      > => {

      const mutationOptions = getUploadDocumentApiProjectsProjectIdDocumentsUploadPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Document
 */
export const updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut = (
    projectId: string,
    documentId: string,
    projectDocumentUpdate: ProjectDocumentUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectDocument>> => {
    
    
    return axios.default.put(
      `/api/projects/${projectId}/documents/${documentId}`,
      projectDocumentUpdate,options
    );
  }



export const getUpdateDocumentApiProjectsProjectIdDocumentsDocumentIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut>>, TError,{projectId: string;documentId: string;data: ProjectDocumentUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut>>, TError,{projectId: string;documentId: string;data: ProjectDocumentUpdate}, TContext> => {

const mutationKey = ['updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut>>, {projectId: string;documentId: string;data: ProjectDocumentUpdate}> = (props) => {
          const {projectId,documentId,data} = props ?? {};

          return  updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut(projectId,documentId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentApiProjectsProjectIdDocumentsDocumentIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut>>>
    export type UpdateDocumentApiProjectsProjectIdDocumentsDocumentIdPutMutationBody = ProjectDocumentUpdate
    export type UpdateDocumentApiProjectsProjectIdDocumentsDocumentIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Document
 */
export const useUpdateDocumentApiProjectsProjectIdDocumentsDocumentIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut>>, TError,{projectId: string;documentId: string;data: ProjectDocumentUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDocumentApiProjectsProjectIdDocumentsDocumentIdPut>>,
        TError,
        {projectId: string;documentId: string;data: ProjectDocumentUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateDocumentApiProjectsProjectIdDocumentsDocumentIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Document
 */
export const deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete = (
    projectId: string,
    documentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/projects/${projectId}/documents/${documentId}`,options
    );
  }



export const getDeleteDocumentApiProjectsProjectIdDocumentsDocumentIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete>>, TError,{projectId: string;documentId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete>>, TError,{projectId: string;documentId: string}, TContext> => {

const mutationKey = ['deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete>>, {projectId: string;documentId: string}> = (props) => {
          const {projectId,documentId} = props ?? {};

          return  deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete(projectId,documentId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentApiProjectsProjectIdDocumentsDocumentIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete>>>
    
    export type DeleteDocumentApiProjectsProjectIdDocumentsDocumentIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Document
 */
export const useDeleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete>>, TError,{projectId: string;documentId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocumentApiProjectsProjectIdDocumentsDocumentIdDelete>>,
        TError,
        {projectId: string;documentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentApiProjectsProjectIdDocumentsDocumentIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Create Project Day
 */
export const createProjectDayApiProjectsProjectIdDaysPost = (
    projectId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectDayWithShotlist>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/days`,undefined,options
    );
  }



export const getCreateProjectDayApiProjectsProjectIdDaysPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectDayApiProjectsProjectIdDaysPost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectDayApiProjectsProjectIdDaysPost>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['createProjectDayApiProjectsProjectIdDaysPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectDayApiProjectsProjectIdDaysPost>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  createProjectDayApiProjectsProjectIdDaysPost(projectId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectDayApiProjectsProjectIdDaysPostMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectDayApiProjectsProjectIdDaysPost>>>
    
    export type CreateProjectDayApiProjectsProjectIdDaysPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Project Day
 */
export const useCreateProjectDayApiProjectsProjectIdDaysPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectDayApiProjectsProjectIdDaysPost>>, TError,{projectId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectDayApiProjectsProjectIdDaysPost>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getCreateProjectDayApiProjectsProjectIdDaysPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Project Day
 */
export const updateProjectDayApiProjectDaysDayIdPut = (
    dayId: string,
    projectDayUpdate: ProjectDayUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProjectDayWithShotlist>> => {
    
    
    return axios.default.put(
      `/api/project-days/${dayId}`,
      projectDayUpdate,options
    );
  }



export const getUpdateProjectDayApiProjectDaysDayIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectDayApiProjectDaysDayIdPut>>, TError,{dayId: string;data: ProjectDayUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectDayApiProjectDaysDayIdPut>>, TError,{dayId: string;data: ProjectDayUpdate}, TContext> => {

const mutationKey = ['updateProjectDayApiProjectDaysDayIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectDayApiProjectDaysDayIdPut>>, {dayId: string;data: ProjectDayUpdate}> = (props) => {
          const {dayId,data} = props ?? {};

          return  updateProjectDayApiProjectDaysDayIdPut(dayId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectDayApiProjectDaysDayIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectDayApiProjectDaysDayIdPut>>>
    export type UpdateProjectDayApiProjectDaysDayIdPutMutationBody = ProjectDayUpdate
    export type UpdateProjectDayApiProjectDaysDayIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Project Day
 */
export const useUpdateProjectDayApiProjectDaysDayIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectDayApiProjectDaysDayIdPut>>, TError,{dayId: string;data: ProjectDayUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectDayApiProjectDaysDayIdPut>>,
        TError,
        {dayId: string;data: ProjectDayUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateProjectDayApiProjectDaysDayIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Create Storyboard
 */
export const createStoryboardApiProjectsProjectIdStoryboardsPost = (
    projectId: string,
    storyboardCreate: StoryboardCreate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Storyboard>> => {
    
    
    return axios.default.post(
      `/api/projects/${projectId}/storyboards`,
      storyboardCreate,options
    );
  }



export const getCreateStoryboardApiProjectsProjectIdStoryboardsPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoryboardApiProjectsProjectIdStoryboardsPost>>, TError,{projectId: string;data: StoryboardCreate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createStoryboardApiProjectsProjectIdStoryboardsPost>>, TError,{projectId: string;data: StoryboardCreate}, TContext> => {

const mutationKey = ['createStoryboardApiProjectsProjectIdStoryboardsPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStoryboardApiProjectsProjectIdStoryboardsPost>>, {projectId: string;data: StoryboardCreate}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createStoryboardApiProjectsProjectIdStoryboardsPost(projectId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateStoryboardApiProjectsProjectIdStoryboardsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createStoryboardApiProjectsProjectIdStoryboardsPost>>>
    export type CreateStoryboardApiProjectsProjectIdStoryboardsPostMutationBody = StoryboardCreate
    export type CreateStoryboardApiProjectsProjectIdStoryboardsPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Create Storyboard
 */
export const useCreateStoryboardApiProjectsProjectIdStoryboardsPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoryboardApiProjectsProjectIdStoryboardsPost>>, TError,{projectId: string;data: StoryboardCreate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStoryboardApiProjectsProjectIdStoryboardsPost>>,
        TError,
        {projectId: string;data: StoryboardCreate},
        TContext
      > => {

      const mutationOptions = getCreateStoryboardApiProjectsProjectIdStoryboardsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Storyboard
 */
export const updateStoryboardApiStoryboardsStoryboardIdPut = (
    storyboardId: string,
    storyboardUpdate: StoryboardUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Storyboard>> => {
    
    
    return axios.default.put(
      `/api/storyboards/${storyboardId}`,
      storyboardUpdate,options
    );
  }



export const getUpdateStoryboardApiStoryboardsStoryboardIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryboardApiStoryboardsStoryboardIdPut>>, TError,{storyboardId: string;data: StoryboardUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoryboardApiStoryboardsStoryboardIdPut>>, TError,{storyboardId: string;data: StoryboardUpdate}, TContext> => {

const mutationKey = ['updateStoryboardApiStoryboardsStoryboardIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoryboardApiStoryboardsStoryboardIdPut>>, {storyboardId: string;data: StoryboardUpdate}> = (props) => {
          const {storyboardId,data} = props ?? {};

          return  updateStoryboardApiStoryboardsStoryboardIdPut(storyboardId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoryboardApiStoryboardsStoryboardIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoryboardApiStoryboardsStoryboardIdPut>>>
    export type UpdateStoryboardApiStoryboardsStoryboardIdPutMutationBody = StoryboardUpdate
    export type UpdateStoryboardApiStoryboardsStoryboardIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Storyboard
 */
export const useUpdateStoryboardApiStoryboardsStoryboardIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryboardApiStoryboardsStoryboardIdPut>>, TError,{storyboardId: string;data: StoryboardUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStoryboardApiStoryboardsStoryboardIdPut>>,
        TError,
        {storyboardId: string;data: StoryboardUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateStoryboardApiStoryboardsStoryboardIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Storyboard
 */
export const deleteStoryboardApiStoryboardsStoryboardIdDelete = (
    storyboardId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/storyboards/${storyboardId}`,options
    );
  }



export const getDeleteStoryboardApiStoryboardsStoryboardIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoryboardApiStoryboardsStoryboardIdDelete>>, TError,{storyboardId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStoryboardApiStoryboardsStoryboardIdDelete>>, TError,{storyboardId: string}, TContext> => {

const mutationKey = ['deleteStoryboardApiStoryboardsStoryboardIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStoryboardApiStoryboardsStoryboardIdDelete>>, {storyboardId: string}> = (props) => {
          const {storyboardId} = props ?? {};

          return  deleteStoryboardApiStoryboardsStoryboardIdDelete(storyboardId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStoryboardApiStoryboardsStoryboardIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStoryboardApiStoryboardsStoryboardIdDelete>>>
    
    export type DeleteStoryboardApiStoryboardsStoryboardIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Storyboard
 */
export const useDeleteStoryboardApiStoryboardsStoryboardIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoryboardApiStoryboardsStoryboardIdDelete>>, TError,{storyboardId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStoryboardApiStoryboardsStoryboardIdDelete>>,
        TError,
        {storyboardId: string},
        TContext
      > => {

      const mutationOptions = getDeleteStoryboardApiStoryboardsStoryboardIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Upload Storyboard Frame
 */
export const uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost = (
    storyboardId: string,
    bodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost: BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StoryboardFrame>> => {
    
    const formData = new FormData();
formData.append(`file`, bodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost.file)
if(bodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost.caption !== undefined && bodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost.caption !== null) {
 formData.append(`caption`, bodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost.caption)
 }

    return axios.default.post(
      `/api/storyboards/${storyboardId}/frames/upload`,
      formData,options
    );
  }



export const getUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPostMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost>>, TError,{storyboardId: string;data: BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost>>, TError,{storyboardId: string;data: BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost}, TContext> => {

const mutationKey = ['uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost>>, {storyboardId: string;data: BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost}> = (props) => {
          const {storyboardId,data} = props ?? {};

          return  uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost(storyboardId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPostMutationResult = NonNullable<Awaited<ReturnType<typeof uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost>>>
    export type UploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPostMutationBody = BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost
    export type UploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPostMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Upload Storyboard Frame
 */
export const useUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost>>, TError,{storyboardId: string;data: BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost>>,
        TError,
        {storyboardId: string;data: BodyUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPost},
        TContext
      > => {

      const mutationOptions = getUploadStoryboardFrameApiStoryboardsStoryboardIdFramesUploadPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update Storyboard Frame
 */
export const updateStoryboardFrameApiStoryboardFramesFrameIdPut = (
    frameId: string,
    storyboardFrameUpdate: StoryboardFrameUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StoryboardFrame>> => {
    
    
    return axios.default.put(
      `/api/storyboard-frames/${frameId}`,
      storyboardFrameUpdate,options
    );
  }



export const getUpdateStoryboardFrameApiStoryboardFramesFrameIdPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryboardFrameApiStoryboardFramesFrameIdPut>>, TError,{frameId: string;data: StoryboardFrameUpdate}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoryboardFrameApiStoryboardFramesFrameIdPut>>, TError,{frameId: string;data: StoryboardFrameUpdate}, TContext> => {

const mutationKey = ['updateStoryboardFrameApiStoryboardFramesFrameIdPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoryboardFrameApiStoryboardFramesFrameIdPut>>, {frameId: string;data: StoryboardFrameUpdate}> = (props) => {
          const {frameId,data} = props ?? {};

          return  updateStoryboardFrameApiStoryboardFramesFrameIdPut(frameId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoryboardFrameApiStoryboardFramesFrameIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoryboardFrameApiStoryboardFramesFrameIdPut>>>
    export type UpdateStoryboardFrameApiStoryboardFramesFrameIdPutMutationBody = StoryboardFrameUpdate
    export type UpdateStoryboardFrameApiStoryboardFramesFrameIdPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Update Storyboard Frame
 */
export const useUpdateStoryboardFrameApiStoryboardFramesFrameIdPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryboardFrameApiStoryboardFramesFrameIdPut>>, TError,{frameId: string;data: StoryboardFrameUpdate}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStoryboardFrameApiStoryboardFramesFrameIdPut>>,
        TError,
        {frameId: string;data: StoryboardFrameUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateStoryboardFrameApiStoryboardFramesFrameIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete Storyboard Frame
 */
export const deleteStoryboardFrameApiStoryboardFramesFrameIdDelete = (
    frameId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.delete(
      `/api/storyboard-frames/${frameId}`,options
    );
  }



export const getDeleteStoryboardFrameApiStoryboardFramesFrameIdDeleteMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoryboardFrameApiStoryboardFramesFrameIdDelete>>, TError,{frameId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStoryboardFrameApiStoryboardFramesFrameIdDelete>>, TError,{frameId: string}, TContext> => {

const mutationKey = ['deleteStoryboardFrameApiStoryboardFramesFrameIdDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStoryboardFrameApiStoryboardFramesFrameIdDelete>>, {frameId: string}> = (props) => {
          const {frameId} = props ?? {};

          return  deleteStoryboardFrameApiStoryboardFramesFrameIdDelete(frameId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStoryboardFrameApiStoryboardFramesFrameIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStoryboardFrameApiStoryboardFramesFrameIdDelete>>>
    
    export type DeleteStoryboardFrameApiStoryboardFramesFrameIdDeleteMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Delete Storyboard Frame
 */
export const useDeleteStoryboardFrameApiStoryboardFramesFrameIdDelete = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoryboardFrameApiStoryboardFramesFrameIdDelete>>, TError,{frameId: string}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStoryboardFrameApiStoryboardFramesFrameIdDelete>>,
        TError,
        {frameId: string},
        TContext
      > => {

      const mutationOptions = getDeleteStoryboardFrameApiStoryboardFramesFrameIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Reorder Storyboard Frames
 */
export const reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut = (
    storyboardId: string,
    storyboardFrameReorder: StoryboardFrameReorder, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StoryboardFrame[]>> => {
    
    
    return axios.default.put(
      `/api/storyboards/${storyboardId}/frames/reorder`,
      storyboardFrameReorder,options
    );
  }



export const getReorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut>>, TError,{storyboardId: string;data: StoryboardFrameReorder}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut>>, TError,{storyboardId: string;data: StoryboardFrameReorder}, TContext> => {

const mutationKey = ['reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut>>, {storyboardId: string;data: StoryboardFrameReorder}> = (props) => {
          const {storyboardId,data} = props ?? {};

          return  reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut(storyboardId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPutMutationResult = NonNullable<Awaited<ReturnType<typeof reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut>>>
    export type ReorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPutMutationBody = StoryboardFrameReorder
    export type ReorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Reorder Storyboard Frames
 */
export const useReorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut>>, TError,{storyboardId: string;data: StoryboardFrameReorder}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPut>>,
        TError,
        {storyboardId: string;data: StoryboardFrameReorder},
        TContext
      > => {

      const mutationOptions = getReorderStoryboardFramesApiStoryboardsStoryboardIdFramesReorderPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Assign Storyboard Frame
 */
export const assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut = (
    itemId: string,
    storyboardFrameAssign: StoryboardFrameAssign, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StoryboardFrame[]>> => {
    
    
    return axios.default.put(
      `/api/shotlist-items/${itemId}/storyboard-frame`,
      storyboardFrameAssign,options
    );
  }



export const getAssignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePutMutationOptions = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut>>, TError,{itemId: string;data: StoryboardFrameAssign}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut>>, TError,{itemId: string;data: StoryboardFrameAssign}, TContext> => {

const mutationKey = ['assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut>>, {itemId: string;data: StoryboardFrameAssign}> = (props) => {
          const {itemId,data} = props ?? {};

          return  assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut(itemId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePutMutationResult = NonNullable<Awaited<ReturnType<typeof assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut>>>
    export type AssignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePutMutationBody = StoryboardFrameAssign
    export type AssignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePutMutationError = AxiosError<HTTPValidationError>

    /**
 * @summary Assign Storyboard Frame
 */
export const useAssignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut = <TError = AxiosError<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut>>, TError,{itemId: string;data: StoryboardFrameAssign}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePut>>,
        TError,
        {itemId: string;data: StoryboardFrameAssign},
        TContext
      > => {

      const mutationOptions = getAssignStoryboardFrameApiShotlistItemsItemIdStoryboardFramePutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Serve Spa
 */
export const serveSpaFullPathGet = (
    fullPath: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    
    return axios.default.get(
      `/${fullPath}`,options
    );
  }




export const getServeSpaFullPathGetQueryKey = (fullPath?: string,) => {
    return [
    `/${fullPath}`
    ] as const;
    }

    
export const getServeSpaFullPathGetQueryOptions = <TData = Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError = AxiosError<HTTPValidationError>>(fullPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServeSpaFullPathGetQueryKey(fullPath);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof serveSpaFullPathGet>>> = ({ signal }) => serveSpaFullPathGet(fullPath, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(fullPath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ServeSpaFullPathGetQueryResult = NonNullable<Awaited<ReturnType<typeof serveSpaFullPathGet>>>
export type ServeSpaFullPathGetQueryError = AxiosError<HTTPValidationError>


export function useServeSpaFullPathGet<TData = Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError = AxiosError<HTTPValidationError>>(
 fullPath: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveSpaFullPathGet>>,
          TError,
          Awaited<ReturnType<typeof serveSpaFullPathGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useServeSpaFullPathGet<TData = Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError = AxiosError<HTTPValidationError>>(
 fullPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveSpaFullPathGet>>,
          TError,
          Awaited<ReturnType<typeof serveSpaFullPathGet>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useServeSpaFullPathGet<TData = Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError = AxiosError<HTTPValidationError>>(
 fullPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Serve Spa
 */

export function useServeSpaFullPathGet<TData = Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError = AxiosError<HTTPValidationError>>(
 fullPath: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveSpaFullPathGet>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getServeSpaFullPathGetQueryOptions(fullPath,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
